<!-- ============================================ -->
<!-- TELA PDV — Layout 4 Colunas (Desktop)        -->
<!-- ============================================ -->
<div class="pdv-root" *ngIf="!isMobile">
  <ng-container *ngIf="centralPedidosBloqueada; else desktopPdvContent">
    <div class="central-home">
      <div class="central-home-head">
        <div class="central-home-title">
          <svg width="27" height="27" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.9.34 1.78.65 2.62a2 2 0 0 1-.45 2.11L8.04 9.96a16 16 0 0 0 6 6l1.51-1.27a2 2 0 0 1 2.11-.45c.84.31 1.72.53 2.62.65A2 2 0 0 1 22 16.92z"/>
          </svg>
          <h1>Central de Pedidos</h1>
        </div>
        <button type="button" class="central-home-back" (click)="goBack()">
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="15 18 9 12 15 6"/>
          </svg>
          Voltar
        </button>
      </div>

      <div class="central-home-search" (click)="abraDialogCentralPedidos()">
        <svg class="central-home-search-icon" width="29" height="29" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
          <circle cx="12" cy="7" r="4"/>
        </svg>
        <input type="text"
               [ngModel]="centralPedidosBusca"
               (ngModelChange)="atualizeBuscaCentralPedidos($event)"
               (click)="abraDialogCentralPedidos()"
               (focus)="abraDialogCentralPedidos()"
               (keyup.enter)="busqueClientesCentralPedidos()"
               placeholder="Buscar cliente por nome ou telefone..."
               appAutoFocus
               [autoFocus]="centralPedidosBloqueada && centralPedidosPodeOperar"
               [disabled]="centralPedidosCarregando || !centralPedidosPodeOperar">
        <span class="central-home-key">F4</span>
        <button type="button"
                class="central-home-search-button"
                (click)="centralPedidosBusca && (centralPedidosBusca || '').trim().length >= 2 ? busqueClientesCentralPedidos() : abraDialogCentralPedidos()"
                [disabled]="centralPedidosCarregando || !centralPedidosPodeOperar || centralPedidosBuscando">
          {{ centralPedidosBuscando ? 'Buscando...' : 'Buscar' }}
        </button>
      </div>

      <div class="central-home-alert is-error" *ngIf="centralPedidosErro">
        {{ centralPedidosErro }}
      </div>
      <div class="central-home-alert" *ngIf="centralPedidosCarregando">
        Carregando configuração da Central...
      </div>

      <div class="central-home-main">
        <section class="central-home-card central-home-attendance">
          <div class="central-card-title">
            <svg class="is-orange" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M3 11a9 9 0 0 1 18 0"/>
              <path d="M21 12v3a2 2 0 0 1-2 2h-1v-6h1a2 2 0 0 1 2 2Z"/>
              <path d="M3 12v3a2 2 0 0 0 2 2h1v-6H5a2 2 0 0 0-2 2Z"/>
            </svg>
            <h2>Atendimento da Central</h2>
          </div>

          <div class="central-attendance-visual" aria-hidden="true">
            <span class="central-mini-node is-store">
              <svg width="23" height="23" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M4 10h16l-2-6H6l-2 6Z"/>
                <path d="M6 10v10h12V10"/>
                <path d="M10 20v-6h4v6"/>
              </svg>
            </span>
            <span class="central-main-node">
              <svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
            </span>
            <span class="central-mini-node is-pin">
              <svg width="23" height="23" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 10c0 7-9 12-9 12S3 17 3 10a9 9 0 1 1 18 0Z"/>
                <circle cx="12" cy="10" r="3"/>
              </svg>
            </span>
          </div>

          <h3>Escolha um cliente para começar</h3>
          <p>
            Selecione um cliente para confirmar o endereço, definir a loja destino e liberar o cardápio.
          </p>

          <div class="central-home-steps" aria-label="Fluxo de entrega da Central de Pedidos">
            <div class="central-home-step is-active">
              <b>1</b>
              <strong>Cliente</strong>
              <small>Buscar e selecionar</small>
            </div>
            <div class="central-home-step">
              <b>2</b>
              <strong>Endereço</strong>
              <small>Confirmar entrega</small>
            </div>
            <div class="central-home-step">
              <b>3</b>
              <strong>Loja destino</strong>
              <small>Resolvida pela Central</small>
            </div>
            <div class="central-home-step">
              <b>4</b>
              <strong>Cardápio</strong>
              <small>Liberar produtos</small>
            </div>
          </div>

        </section>

        <aside class="central-home-side">
          <section class="central-home-card central-home-stores"
                   [class.has-selected]="centralPedidosLojaDestino"
                   [class.is-readonly]="!!centralPedidosClienteSelecionado">
            <div class="central-card-title">
              <svg class="is-blue" width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M4 10h16l-2-6H6l-2 6Z"/>
                <path d="M6 10v10h12V10"/>
                <path d="M10 20v-6h4v6"/>
              </svg>
              <div>
                <h2>Loja de atendimento</h2>
                <small *ngIf="!centralPedidosClienteSelecionado && !centralPedidosLojaDestino">Atalho manual</small>
                <small *ngIf="!centralPedidosClienteSelecionado && centralPedidosLojaManual && centralPedidosLojaDestino">Escolhida manualmente</small>
                <small *ngIf="centralPedidosClienteSelecionado && centralPedidosPreparando && !centralPedidosLojaDestino">Resolvendo loja...</small>
                <small *ngIf="centralPedidosClienteSelecionado && centralPedidosLojaDestino && !centralPedidosLojaManual">Resolvida pelo endereço</small>
                <small *ngIf="centralPedidosClienteSelecionado && centralPedidosLojaDestino && centralPedidosLojaManual">Cliente pediu esta unidade</small>
              </div>
            </div>
            <div class="central-store-picker-summary">
              <span class="central-store-picker-icon">
                <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M4 10h16l-2-6H6l-2 6Z"/>
                  <path d="M6 10v10h12V10"/>
                  <path d="M10 20v-6h4v6"/>
                </svg>
              </span>
              <div class="central-store-picker-copy">
                <strong *ngIf="centralPedidosLojaDestino">{{ centralPedidosLojaDestino.nome }}</strong>
                <strong *ngIf="!centralPedidosLojaDestino && centralPedidosClienteSelecionado && centralPedidosPreparando">Buscando unidade...</strong>
                <strong *ngIf="!centralPedidosLojaDestino && !centralPedidosClienteSelecionado">
                  {{ centralPedidosLojasParticipantes.length }} loja(s) participante(s)
                </strong>

                <small *ngIf="centralPedidosClienteSelecionado && !centralPedidosLojaManual">
                  O sistema escolheu pelo bairro do endereço. Para trocar, ajuste o endereço do cliente.
                </small>
                <small *ngIf="centralPedidosClienteSelecionado && centralPedidosLojaManual">
                  Unidade selecionada manualmente para este cliente.
                </small>
                <small *ngIf="!centralPedidosClienteSelecionado && centralPedidosLojaDestino">
                  {{ centralPedidosLojaDestino.dominio }}
                </small>
                <small *ngIf="!centralPedidosClienteSelecionado && !centralPedidosLojaDestino">
                  Escolha uma loja quando quiser fixar o atendimento antes do cliente.
                </small>
              </div>
            </div>
            <button type="button"
                    class="central-store-picker-button"
                    *ngIf="!centralPedidosClienteSelecionado && !centralPedidosLojaDestino"
                    (click)="abraDialogLojasCentralPedidos()"
                    [disabled]="!centralPedidosPodeOperar || centralPedidosPreparando || !centralPedidosLojasParticipantes.length">
              Escolher loja
            </button>
          </section>

          <section class="central-home-card central-home-tip">
            <div class="central-card-title">
              <svg class="is-blue" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M9 18h6"/>
                <path d="M10 22h4"/>
                <path d="M2 10a10 10 0 1 1 20 0c0 3.2-1.6 5.3-3.6 7.2-.9.8-1.4 1.7-1.4 2.8H7c0-1.1-.5-2-1.4-2.8C3.6 15.3 2 13.2 2 10Z"/>
              </svg>
              <h2>Dica rápida</h2>
            </div>
            <div class="central-tip-body">
              <span>
                <svg width="72" height="72" viewBox="0 0 72 72" fill="none" stroke="currentColor" stroke-width="3">
                  <path d="M56 30c0 16-20 29-20 29S16 46 16 30a20 20 0 1 1 40 0Z"/>
                  <circle cx="36" cy="30" r="8"/>
                </svg>
              </span>
              <p>
                A loja destino será definida depois que o endereço for confirmado.
              </p>
            </div>
          </section>

          <section class="central-home-card central-home-last">
            <div class="central-card-title">
              <svg class="is-blue" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <path d="M12 6v6l4 2"/>
              </svg>
              <h2>Últimos atendimentos</h2>
            </div>
            <div class="central-empty-history">
              <span>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="6" y="4" width="12" height="16" rx="2"/>
                  <path d="M9 4a3 3 0 0 1 6 0"/>
                  <path d="M9 11h6M9 15h4"/>
                </svg>
              </span>
              <p>Nenhum atendimento iniciado ainda</p>
            </div>
          </section>
        </aside>
      </div>

      <div class="central-home-footnote">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z"/>
          <path d="m9 12 2 2 4-5"/>
        </svg>
        <span *ngIf="centralPedidosLojaManual && centralPedidosLojaDestino">
          Loja selecionada manualmente: {{ centralPedidosLojaDestino.nome }}.
          Agora escolha o cliente e endereço para liberar o cardápio.
        </span>
        <span *ngIf="!centralPedidosLojaManual || !centralPedidosLojaDestino">
          Atendimento centralizado e inteligente. A Central resolve automaticamente a loja destino pelo bairro.
        </span>
      </div>
    </div>
  </ng-container>

  <ng-template #desktopPdvContent>
  <div class="pdv-layout"
       [class.is-customize-open]="sbVis && !!selProduct"
       [class.is-central-blocked]="centralPedidosBloqueada">

    <!-- COLUNA 1 — Carrinho (330px) -->
    <div class="cart-col" *ngIf="!centralPedidosBloqueada">
      <div class="cart-header">
        <button class="cart-back" (click)="startNewOrder()" title="Novo atendimento">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <div class="cart-badge" [style.background]="tc.tint" [style.color]="tc.primary">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" [attr.stroke]="tc.primary" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle *ngIf="visualOrderTypeKey==='balcao'" cx="12" cy="12" r="10"/><path *ngIf="visualOrderTypeKey==='balcao'" d="M8 12h8"/>
            <path *ngIf="visualOrderTypeKey==='retirada'" d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline *ngIf="visualOrderTypeKey==='retirada'" points="9 22 9 12 15 12 15 22"/>
            <rect *ngIf="visualOrderTypeKey==='delivery'" x="1" y="3" width="15" height="13"/><circle *ngIf="visualOrderTypeKey==='delivery'" cx="5.5" cy="18.5" r="2.5"/>
            <rect *ngIf="visualOrderTypeKey==='mesa'" x="3" y="3" width="18" height="18" rx="2"/>
          </svg>
          {{ tc.label }} · {{ cart.length }} {{ cart.length === 1 ? 'item' : 'itens' }}
        </div>
      </div>

      <div class="central-pedidos-banner" *ngIf="centralPedidosAtivo" [class.is-resolved]="centralPedidosLojaDestino">
        <span class="central-pedidos-banner-icon" aria-hidden="true">
          <svg *ngIf="!centralPedidosLojaDestino" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="16" x2="12" y2="12"/>
            <line x1="12" y1="8" x2="12.01" y2="8"/>
          </svg>
          <svg *ngIf="centralPedidosLojaDestino" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M4 10h16l-2-6H6l-2 6Z"/>
            <path d="M6 10v10h12V10"/>
            <path d="M10 20v-6h4v6"/>
          </svg>
        </span>
        <div class="central-pedidos-banner-copy">
          <span>{{ centralPedidosLojaDestino ? 'Loja destino' : 'Central de Pedidos' }}</span>
          <strong *ngIf="!centralPedidosLojaDestino">Pedido será criado na loja destino</strong>
          <strong *ngIf="centralPedidosLojaDestino">{{ centralPedidosLojaDestino.nome }}</strong>
          <small *ngIf="centralPedidosLojaDestino">Pedido será criado nesta unidade</small>
        </div>
      </div>

      <!-- Seleção de cliente -->
      <div class="cart-context">
        <div class="central-v3-alert is-error" *ngIf="centralPedidosAtivo && centralPedidosErro">
          {{ centralPedidosErro }}
        </div>
        <div class="central-v3-alert" *ngIf="centralPedidosAtivo && centralPedidosCarregando">
          Carregando configuração da Central...
        </div>
        <div class="central-v3-alert" *ngIf="centralPedidosAtivo && centralPedidosPreparando">
          Preparando atendimento da loja destino...
        </div>

        <div class="ctx-row" *ngIf="isBalcaoMode">
          <div class="ctx-balcao-input-wrapper">
            <label class="ctx-balcao-label">Nome do cliente</label>
            <input
              type="text"
              class="ctx-balcao-input"
              [(ngModel)]="identificacaoBalcao"
              (blur)="onIdentificacaoBalcaoChange()"
              placeholder="Identificação para o pedido"
              maxlength="80"
              [disabled]="salvando">
          </div>
        </div>
        <div class="ctx-row" *ngIf="orderType === 'delivery'">
          <div class="ctx-client-btn" *ngIf="!selectedContact" (click)="openClientModal()">
            <svg class="ctx-icon-left" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#64748b" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            <span class="ctx-btn-text">Buscar por nome ou telefone</span>
            <span class="kbd-badge is-light" *ngIf="!isMobile">F4</span>
            <svg class="ctx-icon-right" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          </div>
          <ng-container *ngIf="selectedContact">
            <div class="ctx-delivery-stack" *ngIf="isDeliveryMode; else ctxSelectedClientSimple">
              <div class="ctx-client-sel ctx-client-sel-customer" (click)="openClientModal()">
                <div class="ctx-avatar" [style.background]="tc.gradient">{{ getClientInitial(selectedContact) }}</div>
                <div class="ctx-client-main">
                  <span class="ctx-client-name">{{ selectedContact.nome }}</span>
                  <span class="ctx-client-phone-row" *ngIf="customerPhone || selectedContact?.telefone">
                    <svg class="ctx-client-phone-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#64748b" stroke-width="2">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.9.34 1.78.65 2.62a2 2 0 0 1-.45 2.11L8.04 9.96a16 16 0 0 0 6 6l1.51-1.27a2 2 0 0 1 2.11-.45c.84.31 1.72.53 2.62.65A2 2 0 0 1 22 16.92z"/>
                    </svg>
                    <span class="ctx-client-phone">{{ selectedContact?.telefone ? (selectedContact.telefone | tel:selectedContact?.codigoPais) : customerPhone }}</span>
                  </span>
                  <button type="button"
                          class="ctx-client-change-action"
                          (click)="abraTrocaClientePedido($event)">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M12 20h9"/>
                      <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"/>
                    </svg>
                    <span>Trocar cliente</span>
                    <span class="kbd-badge is-light" *ngIf="!isMobile">F4</span>
                  </button>
                </div>
                <button class="ctx-client-clear" *ngIf="!centralPedidosAtivo" (click)="clearClient(); $event.stopPropagation()">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                </button>
              </div>

              <div class="ctx-delivery-card" (click)="centralPedidosAtivo && !centralAtendimentoPreparado ? abraDialogCentralPedidos() : openSelectedClientAddressModal($event)">
                <div class="ctx-delivery-address-wrap">
                  <div class="ctx-delivery-address-head">
                    <svg class="ctx-delivery-address-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ea580c" stroke-width="2">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
                    </svg>
                    <span class="ctx-delivery-address-text"
                          *ngIf="(selectedAddress ? getClientAddressFull(selectedAddress) : customerAddress) as deliveryAddressText; else ctxDeliveryNoAddress">
                      {{ deliveryAddressText }}
                    </span>
                  </div>
                  <button type="button"
                          class="ctx-delivery-address-action"
                          (click)="centralPedidosAtivo && !centralAtendimentoPreparado ? abraDialogCentralPedidos() : openSelectedClientAddressModal($event); $event.stopPropagation()">
                    {{ centralPedidosAtivo && !centralAtendimentoPreparado ? 'Revisar endereço' : 'Trocar endereço' }}
                  </button>
                </div>

                <div class="ctx-delivery-divider"></div>

                <div class="ctx-delivery-fee-row" (click)="$event.stopPropagation()">
                  <label class="ctx-delivery-fee-label">Taxa de entrega</label>
                  <div class="ctx-delivery-fee-field">
                    <span class="ctx-delivery-fee-prefix">R$</span>
                    <input class="ctx-delivery-fee-input"
                           [(ngModel)]="deliveryFee"
                           placeholder="0,00"
                           type="text"
                           (click)="$event.stopPropagation()"
                           (focus)="$event.stopPropagation()">
                  </div>
                </div>
                <div class="ctx-delivery-fee-status"
                     *ngIf="deliveryFeeLoading"
                     (click)="$event.stopPropagation()">
                  Calculando taxa...
                </div>
                <div class="ctx-delivery-fee-status is-error"
                     *ngIf="!deliveryFeeLoading && deliveryFeeError"
                     (click)="$event.stopPropagation()">
                  {{ deliveryFeeError }}
                </div>
              </div>
            </div>

            <ng-template #ctxSelectedClientSimple>
              <div class="ctx-client-sel ctx-client-sel-customer" (click)="openClientModal()">
                <div class="ctx-avatar" [style.background]="tc.gradient">{{ getClientInitial(selectedContact) }}</div>
                <div class="ctx-client-main">
                  <span class="ctx-client-name">{{ selectedContact.nome }}</span>
                  <span class="ctx-client-phone-row" *ngIf="customerPhone || selectedContact?.telefone">
                    <svg class="ctx-client-phone-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#64748b" stroke-width="2">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.9.34 1.78.65 2.62a2 2 0 0 1-.45 2.11L8.04 9.96a16 16 0 0 0 6 6l1.51-1.27a2 2 0 0 1 2.11-.45c.84.31 1.72.53 2.62.65A2 2 0 0 1 22 16.92z"/>
                    </svg>
                    <span class="ctx-client-phone">{{ selectedContact?.telefone ? (selectedContact.telefone | tel:selectedContact?.codigoPais) : customerPhone }}</span>
                  </span>
                  <button type="button"
                          class="ctx-client-change-action"
                          (click)="abraTrocaClientePedido($event)">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M12 20h9"/>
                      <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"/>
                    </svg>
                    <span>Trocar cliente</span>
                    <span class="kbd-badge is-light" *ngIf="!isMobile">F4</span>
                  </button>
                </div>
                <button class="ctx-client-clear" *ngIf="!centralPedidosAtivo" (click)="clearClient(); $event.stopPropagation()">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                </button>
              </div>
            </ng-template>
          </ng-container>
          <ng-template #ctxDeliveryNoAddress>
            <span class="ctx-delivery-address-warning">Selecione um endereço de entrega</span>
          </ng-template>
        </div>

        <div class="ctx-row" *ngIf="orderType === 'mesa'">
          <div class="ctx-mesa-highlight">
            <div class="ctx-mesa-head">
              <span class="ctx-mesa-kicker">Mesa selecionada</span>
              <span class="ctx-mesa-number">Mesa {{ mesaNumeroDestaque }}</span>
            </div>
            <div class="ctx-mesa-meta" *ngIf="mesaComandaDestaque || mesaGarcomDestaque">
              <span class="ctx-mesa-chip" *ngIf="mesaComandaDestaque">Comanda {{ mesaComandaDestaque }}</span>
              <span class="ctx-mesa-chip" *ngIf="mesaGarcomDestaque">Garçom {{ mesaGarcomDestaque }}</span>
            </div>
          </div>
          <label class="ctx-label">Número da mesa *</label>
          <input class="ctx-input" [(ngModel)]="tableNum" placeholder="Ex: 5">
          <div class="ctx-row" style="margin-top: 8px;">
            <label class="ctx-label">Nome (opcional)</label>
            <input class="ctx-input" [(ngModel)]="customerName" placeholder="Ex: João">
          </div>
        </div>
      </div>

      <!-- Toggle Retirada / Entrega -->
      <div class="cart-subtype" *ngIf="orderType === 'delivery' && !centralPedidosAtivo">
        <button class="subtype-btn subtype-retirada" [class.active]="subType === 'retirada'" (click)="setSubType('retirada')">
          <span class="subtype-radio">
            <span class="subtype-radio-dot"></span>
          </span>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" [attr.stroke]="subType === 'retirada' ? '#6366f1' : '#94a3b8'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
          Retirada
        </button>
        <button class="subtype-btn subtype-entrega" [class.active]="subType === 'entrega'" (click)="setSubType('entrega')">
          <span class="subtype-radio">
            <span class="subtype-radio-dot"></span>
          </span>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" [attr.stroke]="subType === 'entrega' ? '#ea580c' : '#94a3b8'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>
          Entrega
        </button>
      </div>

      <!-- Itens do carrinho -->
      <div class="cart-items">
        <div class="cart-empty" *ngIf="cart.length === 0">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" stroke-width="1.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
          <span>Carrinho vazio</span>
          <span class="cart-empty-sub">Selecione produtos para começar</span>
        </div>

        <div class="cart-item"
             *ngFor="let item of cart; trackBy: trackById; let i = index"
             (click)="editCartItem(item)"
             [style.animationDelay]="(i * 0.03) + 's'">
          <div class="ci-top">
            <div class="ci-info">
              <span class="ci-name">{{ item.name }}</span>
              <span class="ci-extras" *ngIf="getExtrasText(item)">{{ getExtrasText(item) }}</span>
              <span class="ci-obs" *ngIf="item.obs">{{ item.obs }}</span>
            </div>
            <span class="ci-price">{{ formatCurrency(item.total) }}</span>
          </div>
          <div class="ci-bottom">
            <div class="ci-qty" (click)="$event.stopPropagation()">
              <button type="button"
                      class="ci-qty-btn ci-qty-btn-minus"
                      (click)="updateCartQty(item, -1)"
                      [disabled]="isCartQtyDecreaseDisabled(item)">−</button>
              <span class="ci-qty-val" [class.is-weight]="isCartItemByWeight(item)">{{ getCartQuantityLabel(item) }}</span>
              <button type="button"
                      class="ci-qty-btn ci-qty-btn-plus"
                      (click)="updateCartQty(item, 1)">+</button>
            </div>
            <button type="button" class="ci-remove" (click)="removeCartItem(item); $event.stopPropagation()">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Cart Footer -->
      <div class="cart-footer">
        <div class="cf-subtotal" *ngIf="isDeliveryMode">
          <span>Subtotal</span>
          <span>{{ formatCurrency(cartSubtotal) }}</span>
        </div>
        <div class="cf-fee" *ngIf="isDeliveryMode && deliveryFee">
          <span style="color: #ea580c;">Taxa de entrega</span>
          <span style="color: #ea580c;">{{ formatCurrency(+(deliveryFee) || 0) }}</span>
        </div>
        <div class="cf-total">
          <span>Total</span>
          <span class="cf-total-val">{{ formatCurrency(cartTotal) }}</span>
        </div>
        <button class="cf-btn" *ngIf="!payScreen"
                [style.background]="cart.length > 0 ? tc.gradient : '#cbd5e1'"
                [style.opacity]="(cart.length > 0 && !salvando) ? 1 : 0.5"
                [disabled]="cart.length === 0 || salvando"
                [class.is-loading]="isMesaSending"
                (click)="cart.length > 0 && !salvando && handleFinalizeOrderAction()">
          {{ finalizeOrderButtonLabel }}
          <span class="kbd-badge" *ngIf="!isMobile && !isMesaSending">Enter</span>
        </button>
      </div>
    </div>

    <!-- COLUNA 2+3+4 — Produtos ou Pagamento -->
    <div class="main-area" *ngIf="!payScreen">
      <!-- COLUNA 2 — Categorias (160px) -->
      <div class="cat-col" *ngIf="!centralPedidosBloqueada">
        <div class="cat-topbar">
          <button type="button" class="cat-back-link" (click)="goBack()">
            <i class="fa fa-arrow-left ct-point" aria-hidden="true"></i>
            <span>Voltar</span>
          </button>
        </div>
        <div class="cat-title">CATEGORIAS</div>
        <div class="cat-list">
          <ng-container *ngIf="productsLoading; else catListReady">
            <div class="cat-item cat-skeleton" *ngFor="let sk of categoryLoadingSkeletons; let i = index">
              <span class="cat-skeleton-name skel-shimmer" [style.width.%]="70 - ((i % 3) * 12)"></span>
              <span class="cat-skeleton-count skel-shimmer" [style.width.%]="42 + ((i % 2) * 12)"></span>
            </div>
          </ng-container>
          <ng-template #catListReady>
            <div class="cat-item" *ngFor="let cat of categoryList; trackBy: trackByCat"
                 [class.is-central-locked]="centralPedidosBloqueada"
                 [class.active]="activeCat === cat.nome"
                 [style.borderLeftColor]="activeCat === cat.nome ? cat.cor : 'transparent'"
                 [style.background]="activeCat === cat.nome ? cat.fundo : '#fff'"
                 (click)="centralPedidosBloqueada ? null : selectCategory(cat)">
              <span class="cat-name" [style.color]="activeCat === cat.nome ? cat.cor : '#334155'">
                {{ cat.nome }}
                <svg *ngIf="centralPedidosBloqueada" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="5" y="11" width="14" height="10" rx="2"/>
                  <path d="M8 11V7a4 4 0 0 1 8 0v4"/>
                </svg>
              </span>
              <span class="cat-count-text" [style.color]="activeCat === cat.nome ? cat.cor : '#94a3b8'">{{ cat.count }} {{ cat.count === 1 ? 'item' : 'itens' }}</span>
            </div>
          </ng-template>
        </div>
      </div>

      <!-- COLUNA 3 — Produtos (flex) -->
      <div class="prod-col">
        <div class="prod-header">
          <ng-container *ngIf="centralPedidosBloqueada; else buscaProdutosHeader">
            <div class="prod-search central-client-header-search" (click)="abraDialogCentralPedidos()">
              <svg class="central-header-client-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
              <input type="text"
                     [ngModel]="centralPedidosBusca"
                     (ngModelChange)="atualizeBuscaCentralPedidos($event)"
                     (click)="abraDialogCentralPedidos()"
                     (focus)="abraDialogCentralPedidos()"
                     (keyup.enter)="busqueClientesCentralPedidos()"
                     placeholder="Buscar cliente por nome ou telefone..."
                     class="search-input"
                     appAutoFocus
                     [autoFocus]="centralPedidosBloqueada && centralPedidosPodeOperar"
                     [disabled]="centralPedidosCarregando || !centralPedidosPodeOperar">
              <i class="fa fa-whatsapp central-header-whatsapp" aria-hidden="true"></i>
              <button type="button"
                      class="central-header-search-button"
                      (click)="centralPedidosBusca && (centralPedidosBusca || '').trim().length >= 2 ? busqueClientesCentralPedidos() : abraDialogCentralPedidos()"
                      [disabled]="centralPedidosCarregando || !centralPedidosPodeOperar || centralPedidosBuscando">
                {{ centralPedidosBuscando ? 'Buscando...' : 'Buscar' }}
              </button>
            </div>
          </ng-container>
          <ng-template #buscaProdutosHeader>
            <div class="prod-search">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              <input type="text" [(ngModel)]="search" placeholder="Buscar produto ou código..." class="search-input">
              <span class="prod-count" [class.loading]="productsLoading">
                {{ productsLoading ? 'Carregando...' : (filteredProducts.length + ' Itens') }}
              </span>
              <button type="button" class="prod-photo-toggle"
                      [class.active]="showProductPhotos"
                      (click)="toggleProductPhotos()"
                      [title]="showProductPhotos ? 'Ocultar fotos' : 'Mostrar fotos'">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                  <circle cx="8.5" cy="8.5" r="1.5"/>
                  <polyline points="21 15 16 10 5 21"/>
                </svg>
              </button>
            </div>
          </ng-template>
          <div class="prod-loading-status" *ngIf="productsLoading">
            <div class="pls-chip">
              <span class="pls-chip-dot"></span>
              <span>Carregando os Produtos</span>
            </div>
            <div class="pls-track">
              <div class="pls-track-fill"></div>
            </div>
            <div class="pls-dots" aria-hidden="true">
              <span class="pls-dot"></span>
              <span class="pls-dot"></span>
              <span class="pls-dot"></span>
            </div>
          </div>
        </div>
        <div class="prod-grid" [class.is-loading]="productsLoading">
          <ng-container *ngIf="centralPedidosBloqueada; else prodGridLiberado">
            <div class="central-v3-prod-locked">
              <div class="central-start-content">
                <div class="central-v3-prod-locked-icon">
                  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M3 11a9 9 0 0 1 18 0"/>
                    <path d="M21 12v3a2 2 0 0 1-2 2h-1v-6h1a2 2 0 0 1 2 2Z"/>
                    <path d="M3 12v3a2 2 0 0 0 2 2h1v-6H5a2 2 0 0 0-2 2Z"/>
                    <path d="M13 19h2a4 4 0 0 0 4-4"/>
                  </svg>
                </div>
                <span>Central de Pedidos</span>
                <strong>Escolha o cliente para iniciar o pedido</strong>
                <small>A Central encontra o cadastro, confirma o endereço e libera o cardápio da loja destino.</small>

                <div class="central-start-note">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z"/>
                    <path d="m9 12 2 2 4-5"/>
                  </svg>
                  <p>Se o cliente existir em mais de uma loja, escolha o endereço correto. A Central resolverá a loja destino automaticamente pelo bairro.</p>
                </div>

                <div class="central-start-steps" aria-hidden="true">
                  <div class="central-start-step is-active">
                    <b>1</b>
                    <strong>Cliente</strong>
                    <small>Buscar cadastro</small>
                  </div>
                  <div class="central-start-step">
                    <b>2</b>
                    <strong>Endereço</strong>
                    <small>Confirmar entrega</small>
                  </div>
                  <div class="central-start-step">
                    <b>3</b>
                    <strong>Loja destino</strong>
                    <small>Resolvida pela Central</small>
                  </div>
                  <div class="central-start-step">
                    <b>4</b>
                    <strong>Cardápio</strong>
                    <small>Liberar produtos</small>
                  </div>
                </div>

              </div>

              <div class="central-route-visual" aria-hidden="true">
                <div class="central-route-node is-headset">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M3 11a9 9 0 0 1 18 0"/>
                    <path d="M21 12v3a2 2 0 0 1-2 2h-1v-6h1a2 2 0 0 1 2 2Z"/>
                    <path d="M3 12v3a2 2 0 0 0 2 2h1v-6H5a2 2 0 0 0-2 2Z"/>
                  </svg>
                </div>
                <div class="central-route-card">
                  <svg width="44" height="32" viewBox="0 0 44 32" fill="none" stroke="currentColor" stroke-width="2">
                    <rect x="2" y="3" width="40" height="26" rx="4"/>
                    <circle cx="14" cy="14" r="4"/>
                    <path d="M8 24c2-4 10-4 12 0"/>
                    <path d="M27 12h9M27 19h7"/>
                  </svg>
                </div>
                <div class="central-route-node is-pin">
                  <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M21 10c0 7-9 12-9 12S3 17 3 10a9 9 0 1 1 18 0Z"/>
                    <circle cx="12" cy="10" r="3"/>
                  </svg>
                </div>
                <div class="central-route-store">
                  <svg width="46" height="42" viewBox="0 0 46 42" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M8 18h30l-3-12H11L8 18Z"/>
                    <path d="M10 18v18h26V18"/>
                    <path d="M18 36V25h10v11"/>
                    <path d="M8 18c0 3 2 5 5 5s5-2 5-5c0 3 2 5 5 5s5-2 5-5c0 3 2 5 5 5s5-2 5-5"/>
                  </svg>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #prodGridLiberado>
          <ng-container *ngIf="productsLoading; else prodGridReady">
            <div class="prod-loading-banner">
              <div class="plb-left">
                <span class="plb-pill skel-shimmer"></span>
                <span class="plb-title skel-shimmer"></span>
                <span class="plb-sub skel-shimmer"></span>
              </div>
              <div class="plb-right">
                <span class="plb-stat skel-shimmer"></span>
                <span class="plb-stat-sm skel-shimmer"></span>
              </div>
            </div>
            <div class="prod-card prod-card-skeleton" *ngFor="let sk of productLoadingSkeletons; let i = index"
                 [style.animationDelay]="(i * 0.03) + 's'">
              <div class="pcs-img skel-shimmer"></div>
              <div class="pcs-top">
                <span class="pcs-chip skel-shimmer"></span>
              </div>
              <div class="pcs-line pcs-line-lg skel-shimmer"></div>
              <div class="pcs-line pcs-line-md skel-shimmer"></div>
              <div class="pcs-bottom">
                <div class="pcs-price-wrap">
                  <span class="pcs-price-sub skel-shimmer"></span>
                  <span class="pcs-price skel-shimmer"></span>
                </div>
                <span class="pcs-btn skel-shimmer"></span>
              </div>
            </div>
          </ng-container>
          <ng-template #prodGridReady>
            <div class="prod-card" *ngFor="let p of filteredProducts; trackBy: trackById"
                 [class.is-selected]="selProduct?.id === p.id"
                 [class.is-customizable]="isProductCustomizable(p)"
                 [class.is-popular]="p._popular"
                 [class.has-image]="showProductPhotos"
                 (click)="addToCart(p)">
              <ng-container *ngIf="showProductPhotos">
                <div class="pc-img-wrap" *ngIf="p._image">
                  <img [src]="p._image" [alt]="p.nome" class="pc-img" loading="lazy"
                       (error)="onProductImageError(p)">
                  <span class="pc-popular pc-popular--overlay" *ngIf="p._popular">POPULAR</span>
                </div>
                <div class="pc-img-placeholder" *ngIf="!p._image">
                  <span class="pc-img-emoji">🍽️</span>
                  <span class="pc-popular pc-popular--overlay" *ngIf="p._popular">POPULAR</span>
                </div>
              </ng-container>
              <div class="pc-top" *ngIf="!showProductPhotos && p._popular">
                <span class="pc-popular">POPULAR</span>
              </div>
              <div class="pc-body">
                <span class="pc-name">{{ p.nome }}</span>
                <div class="pc-bottom">
                  <div class="pc-price-wrap">
                    <span class="pc-from" *ngIf="isProductCustomizable(p) && !isWeightProduct(p)">A partir de</span>
                    <span class="pc-price">
                      {{ formatCurrency(getProductPrice(p)) }}
                      <span class="pc-price-unit" *ngIf="isWeightProduct(p)">/{{ getWeightPriceUnitLabel(p) }}</span>
                    </span>
                  </div>
                  <button class="pc-add-btn"
                          [class.is-customizable]="isProductCustomizable(p)"
                          [class.is-popular]="p._popular && !isProductCustomizable(p)"
                          (click)="addToCart(p); $event.stopPropagation()">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                    <span class="pc-edit-indicator" *ngIf="isProductCustomizable(p)">
                      <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M12 20h9"/>
                        <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/>
                      </svg>
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <div class="prod-empty" *ngIf="filteredProducts.length === 0">
              <span>Nenhum produto encontrado</span>
            </div>
          </ng-template>
          </ng-template>
        </div>
      </div>

      <!-- COLUNA 4 — Sidebar de Personalização (360px) -->
      <div class="sb-col" [class.sb-visible]="sbVis && selProduct" (click)="(sbVis && selProduct) && closeCustomize()">
        <div class="sb-backdrop" aria-hidden="true"></div>
        <div class="sb-panel" *ngIf="selProduct" (click)="$event.stopPropagation()">
          <div class="sb-content">
            <div class="sb-header">
              <div class="sb-header-left">
                <div class="sb-pcode-badge">{{ getProductCode(selProduct) }}</div>
                <div class="sb-pinfo">
                  <span class="sb-pcode-text">{{ getProductCode(selProduct) }}</span>
                  <span class="sb-pname-top">{{ selProduct.nome }}</span>
                </div>
              </div>
              <button class="sb-close" type="button" (click)="closeCustomize()">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#64748b" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>

            <div class="sb-price-row">
              <div class="sb-price-box">
                <span class="sb-price-label">{{ isSelectedWeightProduct() ? ('Preço por ' + getWeightPriceUnitLabel(selProduct)) : 'A partir de' }}</span>
                <span class="sb-price-val">{{ isSelectedWeightProduct() ? formatCurrency(getProductPrice(selProduct)) : formatCurrency(customizeTotal) }}</span>
              </div>
            </div>

            <!-- Quantidade -->
            <div class="sb-qty-section" *ngIf="!isSelectedWeightProduct(); else desktopWeightSection">
              <div class="sb-qty-row">
                <label class="sb-label-main">Quantidade</label>
                <div class="sb-qty-selector">
                  <button type="button" class="tbtn-circle" (click)="decreaseCustomizeQty()" [disabled]="isCustomizeQtyDecreaseDisabled()">−</button>
                  <span class="sb-qty-num">{{ qty }}</span>
                  <button type="button" class="tbtn-circle" (click)="increaseCustomizeQty()">+</button>
                </div>
              </div>
            </div>
            <ng-template #desktopWeightSection>
              <div class="sb-weight-section">
                <div class="sb-weight-alert">
                  <span class="sb-weight-alert-dot"></span>
                  <div>
                    <strong>Balança não conectada</strong>
                    <span>Insira o peso do item manualmente para calcular o valor</span>
                  </div>
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </div>
                <div class="sb-weight-grid">
                  <div class="sb-weight-field">
                    <label class="sb-label-main">Peso do item</label>
                    <div class="sb-weight-input-row">
                      <button type="button" class="tbtn-circle" (click)="changeWeightQuantity(-1)" [disabled]="isCustomizeQtyDecreaseDisabled()">−</button>
                      <div class="sb-weight-input-wrap">
                        <input class="sb-weight-input"
                               type="number"
                               [ngModel]="qty"
                               (ngModelChange)="setWeightQuantity($event)"
                               [step]="getWeightIncrement(selProduct)"
                               [min]="getWeightMinimumInput(selProduct)"
                               [attr.max]="getWeightMaximumInput(selProduct)">
                        <span>{{ getWeightUnit(selProduct) }}</span>
                      </div>
                      <button type="button" class="tbtn-circle" (click)="changeWeightQuantity(1)">+</button>
                    </div>
                    <span class="sb-label-sub">Calculado automaticamente com base no peso por {{ getWeightUnit(selProduct) }}</span>
                  </div>
                  <div class="sb-weight-field">
                    <label class="sb-label-main">Valor calculado</label>
                    <div class="sb-weight-readonly">{{ formatCurrency(customizeTotal) }}</div>
                  </div>
                </div>
              </div>
            </ng-template>
            <div class="sb-divider"></div>

            <div class="sb-scroll">
              <div class="sb-section"
                   *ngFor="let field of selProductOrderedFields; trackBy: trackByFieldKey"
                   [attr.data-field-key]="field.fieldKey"
                   [attr.data-shake-key]="getFieldShakeKey(field)">
                <div class="sb-section-header">
                  <div class="sb-section-title">
                    <label class="sb-label-main">{{ field.name }}</label>
                    <span class="sb-label-sub" *ngIf="field.kind === 'repeat'">Escolha a quantidade de cada</span>
                    <span class="sb-label-sub" *ngIf="field.kind === 'multi'">Selecione as opções</span>
                    <span class="sb-label-sub" *ngIf="field.kind === 'single'">Escolha 1 opção</span>
                  </div>
                  <div class="sb-header-meta">
                    <span class="sb-required-badge" *ngIf="field.required || (field.min || 0) > 0">OBRIGATÓRIO</span>
                    <span class="sb-counter" [class.active]="isFieldCounterActive(field)">
                      {{ getFieldCounterText(field) }}
                    </span>
                  </div>
                </div>

                <ng-container [ngSwitch]="field.kind">
                  <div class="sb-extras-list" *ngSwitchCase="'repeat'">
                    <div class="sb-extra-item" *ngFor="let option of field.options; trackBy: trackByOptionKey"
                         [class.active]="getRepeatQty(field, option) > 0"
                         [class.error]="fieldHasError(field)">
                      <div class="sb-extra-info">
                        <span class="sb-extra-name">{{ option.name }}</span>
                        <span class="sb-extra-badge" *ngIf="option.price > 0">+{{ formatCurrency(option.price) }}</span>
                      </div>
                      <div class="sb-extra-controls">
                        <button type="button" class="tbtn-xs" (click)="changeRepeatQty(field, option, -1); $event.stopPropagation()"
                                [disabled]="getRepeatQty(field, option) <= 0">−</button>
                        <span class="sb-extra-qty-num">{{ getRepeatQty(field, option) }}</span>
                        <button type="button" class="tbtn-xs" (click)="changeRepeatQty(field, option, 1); $event.stopPropagation()">+</button>
                      </div>
                    </div>
                  </div>

                  <div class="sb-choice-list" *ngSwitchCase="'multi'">
                    <button type="button" class="sb-choice-item" *ngFor="let option of field.options; trackBy: trackByOptionKey"
                            [class.active]="isMultiSelected(field, option)"
                            [class.error]="fieldHasError(field)"
                            (click)="toggleMultiChoice(field, option)">
                      <span class="sb-choice-check">
                        <svg *ngIf="isMultiSelected(field, option)" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3">
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                      </span>
                      <span class="sb-choice-name">{{ option.name }}</span>
                      <span class="sb-choice-badge" *ngIf="option.price > 0">+{{ formatCurrency(option.price) }}</span>
                    </button>
                  </div>

                  <div class="sb-radio-row" *ngSwitchDefault>
                    <div class="sb-radio-card" *ngFor="let option of field.options; trackBy: trackByOptionKey"
                         [class.active]="isSingleSelected(field, option)"
                         [class.error]="fieldHasError(field)"
                         (click)="selectSingleChoice(field, option)">
                      <div class="sb-radio-circle"></div>
                      <span class="sb-radio-label">{{ option.name }}</span>
                      <span class="sb-radio-price" *ngIf="option.price > 0">+{{ formatCurrency(option.price) }}</span>
                    </div>
                  </div>
                </ng-container>

                <div class="sb-error" *ngIf="fieldHasError(field)">{{ fieldErrorText(field) }}</div>
              </div>

              <!-- Desconto -->
              <div class="sb-section">
                <label class="sb-label-main">Desconto</label>
                <div class="sb-input-wrapper">
                  <span class="sb-input-prefix">R$</span>
                  <input class="sb-input-field" [(ngModel)]="discount" placeholder="0,00" type="text">
                </div>
              </div>

              <!-- Observações -->
              <div class="sb-section">
                <label class="sb-label-main">Observação</label>
                <textarea class="sb-textarea" [(ngModel)]="obs" placeholder="Ex: sem calda, bem gelado..." rows="2"></textarea>
              </div>
            </div>
          </div>

          <!-- Footer sidebar -->
          <div class="sb-footer">
            <button class="sb-btn-cancel" type="button" (click)="closeCustomize()">Cancelar</button>
            <button class="sb-btn-add" type="button" (click)="confirmCustomize()">
              {{ editingItem ? 'Salvar Alteração' : 'Adicionar ' + formatCurrency(customizeTotal) }}
              <span class="sb-btn-badge">Enter ↵</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- ============================================ -->
    <!-- TELA PAGAMENTO (substitui colunas 2-4)       -->
    <!-- ============================================ -->
    <div class="pay-area" *ngIf="payScreen">
      <div class="pay-header">
        <div class="pay-shell">
          <div class="pay-header-row">
            <div class="pay-header-left">
              <button class="pay-back" (click)="closePayScreen()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#64748b" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>
              </button>
              <div class="pay-title-group">
                <span class="pay-title">Pagamento</span>
                <span class="pay-subtitle">{{ cart.length }} {{ cart.length === 1 ? 'item' : 'itens' }} no pedido</span>
              </div>
            </div>
            <div class="pay-total-display">
              <span class="pay-total-label">Total</span>
              <span class="pay-total-value">{{ formatCurrency(payFinalTotal) }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="pay-body">
        <div class="pay-shell">
          <div class="pay-layout-grid">
            <div class="pay-col-main">
              <div class="pay-req-alert"
                   *ngIf="shouldShowMissingDeliveryAddressAlert"
                   (click)="selectedContact?.id ? openSelectedClientAddressModal() : openClientModal()">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#ea580c" stroke-width="2">
                  <path d="M12 9v4"/><path d="M12 17h.01"/><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                </svg>
                <span>{{ selectedContact?.id ? 'Selecione um endereço para confirmar o pedido de entrega.' : 'Selecione cliente e endereço para confirmar o pedido de entrega.' }}</span>
              </div>

              <div class="pay-discount-section">
                <p class="pay-section-kicker">Descontos e Benefícios</p>
                <div class="pd-main-row">
                  <div class="pd-input-group">
                    <div class="pd-toggle-wrap">
                      <button class="pd-toggle"
                              [style.background]="payDiscountType === 'R$' ? '#6366f1' : '#f8fafc'"
                              [style.color]="payDiscountType === 'R$' ? '#fff' : '#64748b'"
                              (click)="payDiscountType = 'R$'">R$</button>
                      <button class="pd-toggle"
                              [style.background]="payDiscountType === '%' ? '#6366f1' : '#f8fafc'"
                              [style.color]="payDiscountType === '%' ? '#fff' : '#64748b'"
                              (click)="payDiscountType = '%'">%</button>
                    </div>
                    <input class="pd-input pd-input-discount" [(ngModel)]="payDiscount" placeholder="0,00" type="number">
                  </div>
                </div>
                <div class="pd-cupom-row">
                  <div class="pd-cupom-wrap">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="2"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
                    <input class="pd-input pd-cupom" [(ngModel)]="payCupom" placeholder="Código do cupom">
                  </div>
                  <button class="pd-apply-btn" type="button">Aplicar</button>
                </div>
              </div>

              <div class="pay-cashback-card" *ngIf="showCashbackPanel">
                <div class="pcb-head">
                  <div class="pcb-title-wrap">
                    <span class="pcb-title">Cashback</span>
                    <span class="pcb-badge">Saldo disponível</span>
                  </div>
                  <span class="pcb-balance">{{ formatCurrency(cashbackAvailableAmount) }}</span>
                </div>

                <p class="pcb-hint" *ngIf="!hasCashbackPaymentMethodConfigured">
                  Habilite a forma de pagamento em cashback para usar o saldo neste pedido.
                </p>

                <div class="pcb-actions" *ngIf="hasCashbackPaymentMethodConfigured && !usarSaldoCashback">
                  <button type="button" class="pcb-btn" (click)="activateCashbackUsage()">Usar saldo</button>
                </div>

                <div class="pcb-editor" *ngIf="hasCashbackPaymentMethodConfigured && usarSaldoCashback">
                  <label class="pcb-label">Quanto do cashback vai usar?</label>
                  <div class="pcb-input-row">
                    <span class="pcb-curr">R$</span>
                    <input class="pcb-input"
                           type="number"
                           step="0.01"
                           min="0"
                           [max]="cashbackMaxUsable"
                           [(ngModel)]="cashbackState.valor"
                           (ngModelChange)="onCashbackValueChange()">
                    <button type="button" class="pcb-remove" (click)="disableCashbackUsage()">Remover</button>
                  </div>
                  <div class="pcb-meta">
                    <span>Máximo: {{ formatCurrency(cashbackMaxUsable) }}</span>
                    <span *ngIf="cashbackAppliedValue > 0">Aplicado: {{ formatCurrency(cashbackAppliedValue) }}</span>
                  </div>
                </div>
              </div>

              <div class="pay-methods-panel">
                <p class="pay-section-kicker">{{ isSplit ? 'Divisão do pagamento' : 'Forma de pagamento' }}</p>

                <div class="pay-methods-selected" *ngIf="isSplit">
                  <div class="pms-card"
                       *ngFor="let pm of payMethods; let i = index; trackBy: trackBySelectedPayMethod"
                       [class.compact]="isCompact"
                       [class.is-rest]="i === restanteIdx"
                       [style.borderColor]="i === restanteIdx ? '#6366f1' : (pm.color + '30')">
                    <div class="pms-top" [class.is-rest]="i === restanteIdx" [style.background]="i === restanteIdx ? '#eef2ff' : (pm.color + '06')">
                      <div class="pms-info">
                        <div class="pms-icon-circle" [style.background]="i === restanteIdx ? '#6366f120' : (pm.color + '15')">
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" [attr.stroke]="i === restanteIdx ? '#6366f1' : pm.color" stroke-width="2">
                            <rect *ngIf="pm.icon==='card'" x="1" y="4" width="22" height="16" rx="2" ry="2"/><line *ngIf="pm.icon==='card'" x1="1" y1="10" x2="23" y2="10"/>
                            <rect *ngIf="pm.icon==='banknote'" x="2" y="6" width="20" height="12" rx="2"/><circle *ngIf="pm.icon==='banknote'" cx="12" cy="12" r="2"/>
                            <rect *ngIf="pm.icon==='qr'" x="3" y="3" width="7" height="7"/><rect *ngIf="pm.icon==='qr'" x="14" y="3" width="7" height="7"/><rect *ngIf="pm.icon==='qr'" x="3" y="14" width="7" height="7"/>
                            <rect *ngIf="pm.icon==='wallet'" x="2" y="5" width="20" height="14" rx="2"/><path *ngIf="pm.icon==='wallet'" d="M16 12h2"/>
                          </svg>
                        </div>
                        <span class="pms-name" [style.color]="i === restanteIdx ? '#6366f1' : pm.color">
                          {{ pm.name }}
                          <span *ngIf="pm.original?.fiado === true" class="pg-fiado-badge">Fiado</span>
                        </span>
                        <span class="pms-restante-badge" *ngIf="i === restanteIdx">Restante</span>
                      </div>
                      <button class="pms-remove" *ngIf="!isCompact" (click)="removePayMethod(pm.id)">Remover</button>
                      <button class="pms-remove-x" *ngIf="isCompact" (click)="removePayMethod(pm.id)">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#dc2626" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                      </button>
                    </div>
                    <div class="pms-amount">
                      <span class="pms-curr">R$</span>
                      <input class="pms-amount-input"
                             [class.is-rest]="i === restanteIdx"
                             [(ngModel)]="pm.amount"
                             type="number"
                             step="0.01"
                             (ngModelChange)="onPayAmountChange(i)">
                    </div>
                  </div>

                  <div class="split-status">
                    <div class="ss-bar ss-warning" *ngIf="splitHasEmpty">
                      Digite um valor na forma adicionada ou remova-a.
                    </div>
                    <div class="ss-bar ss-error" *ngIf="!splitHasEmpty && splitOverflow">
                      Soma excede o total em {{ formatCurrency(payPaidTotal - payFinalTotal) }}
                    </div>
                    <div class="ss-bar ss-warning" *ngIf="!splitHasEmpty && !splitOverflow && payRemaining > 0">
                      Faltam {{ formatCurrency(payRemaining) }}
                    </div>
                    <div class="ss-bar ss-success" *ngIf="!splitHasEmpty && !splitOverflow && payRemaining === 0">
                      <span>Total: <b>{{ formatCurrency(payFinalTotal) }}</b></span>
                      <span>✓ Divisão fechada</span>
                    </div>
                  </div>

                  <button class="pay-add-method" (click)="openAddPayMethod()" *ngIf="!showPayGrid">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#6366f1" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                    Adicionar forma
                    <span class="kbd-badge" *ngIf="!isMobile">F3</span>
                  </button>
                </div>

                <div class="pay-method-single" *ngIf="payMethods.length === 1">
                  <div class="pms-single-card"
                       [style.borderColor]="payMethods[0].color"
                       [style.background]="payMethods[0].color + '06'">
                    <div class="pms-info">
                      <div class="pms-icon-circle" [style.background]="payMethods[0].color + '15'">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" [attr.stroke]="payMethods[0].color" stroke-width="2">
                          <rect *ngIf="payMethods[0].icon==='card'" x="1" y="4" width="22" height="16" rx="2" ry="2"/><line *ngIf="payMethods[0].icon==='card'" x1="1" y1="10" x2="23" y2="10"/>
                          <rect *ngIf="payMethods[0].icon==='banknote'" x="2" y="6" width="20" height="12" rx="2"/><circle *ngIf="payMethods[0].icon==='banknote'" cx="12" cy="12" r="2"/>
                          <rect *ngIf="payMethods[0].icon==='qr'" x="3" y="3" width="7" height="7"/><rect *ngIf="payMethods[0].icon==='qr'" x="14" y="3" width="7" height="7"/><rect *ngIf="payMethods[0].icon==='qr'" x="3" y="14" width="7" height="7"/>
                          <rect *ngIf="payMethods[0].icon==='wallet'" x="2" y="5" width="20" height="14" rx="2"/><path *ngIf="payMethods[0].icon==='wallet'" d="M16 12h2"/>
                        </svg>
                      </div>
                      <div class="pms-text">
                        <span class="pms-name" [style.color]="payMethods[0].color">
                          {{ payMethods[0].name }}
                          <span *ngIf="payMethods[0].original?.fiado === true" class="pg-fiado-badge">Fiado</span>
                        </span>
                        <span class="pms-desc" *ngIf="payMethods[0].desc">{{ payMethods[0].desc }}</span>
                      </div>
                    </div>
                    <span class="pms-single-amount">{{ formatCurrency(payMethods[0].amount || 0) }}</span>
                    <button class="pms-remove-x" (click)="removePayMethod(payMethods[0].id)">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#dc2626" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                    </button>
                  </div>

                  <div class="pay-troco pay-troco-inline" *ngIf="hasDinheiro">
                    <div class="pt-header">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2"><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="2"/></svg>
                      <label>Troco para</label>
                    </div>
                    <div class="pt-input-group">
                      <span class="pt-curr">R$</span>
                      <input class="pt-input" [(ngModel)]="payTroco" placeholder="0,00" type="number">
                    </div>
                    <div class="pt-result" *ngIf="trocoValue > 0">Troco: <strong>{{ formatCurrency(trocoValue) }}</strong></div>
                  </div>

                  <button class="pay-add-inline" (click)="openAddPayMethod()" *ngIf="!showPayGrid">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#6366f1" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                    Adicionar outra forma (dividir pagamento)
                    <span class="kbd-badge" *ngIf="!isMobile">F3</span>
                  </button>
                </div>

                <div class="pay-troco" *ngIf="isSplit && hasDinheiro">
                  <div class="pt-header">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2"><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="2"/></svg>
                    <label>Troco para</label>
                  </div>
                  <div class="pt-input-group">
                    <span class="pt-curr">R$</span>
                    <input class="pt-input" [(ngModel)]="payTroco" placeholder="0,00" type="number">
                  </div>
                  <div class="pt-result" *ngIf="trocoValue > 0">Troco: <strong>{{ formatCurrency(trocoValue) }}</strong></div>
                </div>

                <div class="pay-grid" id="payGrid" *ngIf="payMethods.length === 0 || showPayGrid">
                  <div class="pg-divider" *ngIf="payMethods.length > 0 && payMethodSectionsView.length > 0">Selecione</div>

                  <div class="pg-empty" *ngIf="payMethodSectionsView.length === 0">
                    Nenhuma forma de pagamento disponível para este tipo de pedido.
                  </div>

                  <div class="pg-section" *ngFor="let section of payMethodSectionsView; trackBy: trackByPaySection">
                    <div class="pg-section-header">
                      <span class="pg-section-title">{{ section.title }}</span>
                      <span class="pg-section-badge"
                            [style.background]="section.badgeColor + '15'"
                            [style.color]="section.badgeColor">{{ section.badge }}</span>
                    </div>

                    <div class="pg-cards">
                      <button type="button"
                              class="pg-card"
                              *ngFor="let m of section.methods; trackBy: trackByPayMethod"
                              (click)="selectPayMethod(m)"
                              [attr.aria-label]="'Selecionar forma de pagamento ' + m.name">
                        <div class="pms-icon-circle pg-card-icon">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="2">
                            <rect *ngIf="m.icon==='card'" x="1" y="4" width="22" height="16" rx="2" ry="2"/><line *ngIf="m.icon==='card'" x1="1" y1="10" x2="23" y2="10"/>
                            <rect *ngIf="m.icon==='banknote'" x="2" y="6" width="20" height="12" rx="2"/><circle *ngIf="m.icon==='banknote'" cx="12" cy="12" r="2"/>
                            <rect *ngIf="m.icon==='qr'" x="3" y="3" width="7" height="7"/><rect *ngIf="m.icon==='qr'" x="14" y="3" width="7" height="7"/><rect *ngIf="m.icon==='qr'" x="3" y="14" width="7" height="7"/>
                            <rect *ngIf="m.icon==='wallet'" x="2" y="5" width="20" height="14" rx="2"/><path *ngIf="m.icon==='wallet'" d="M16 12h2"/>
                          </svg>
                        </div>
                        <div class="pg-card-info">
                          <span class="pg-card-name">
                            {{ m.name }}
                            <span *ngIf="m.original?.fiado === true" class="pg-fiado-badge">Fiado</span>
                          </span>
                          <span class="pg-card-desc" *ngIf="m.desc">{{ m.desc }}</span>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="pay-paid-card" *ngIf="orderType !== 'mesa'">
                <label class="pay-paid-toggle" [class.is-disabled]="!canMarkOrderPaidOnCreate">
                  <input type="checkbox"
                         [checked]="marcarPedidoComoPago"
                         [disabled]="!canMarkOrderPaidOnCreate"
                         (change)="toggleMarkOrderPaid($any($event.target).checked)">
                  <span class="pay-section-kicker">Marcar pedido como pago</span>
                  <small class="pay-paid-hint" *ngIf="isBalcaoMode && canMarkOrderPaidOnCreate">
                    Pedidos de balcão já ficam desmarcados por padrão.
                  </small>
                  <small class="pay-paid-hint" *ngIf="!canMarkOrderPaidOnCreate">
                    Disponível apenas para pagamento presencial, sem fiado.
                  </small>
                </label>
              </div>

              <div class="pay-schedule-card" *ngIf="permiteAgendamentoPedido">
                <label class="pay-schedule-toggle" [class.is-required]="agendamentoObrigatorio">
                  <input type="checkbox"
                         [checked]="agendarEntrega"
                         [disabled]="agendamentoObrigatorio"
                         (change)="onToggleAgendarEntrega($any($event.target).checked)">
                  <span class="pay-section-kicker">Agendar pedido</span>
                  <span class="pay-schedule-badge" *ngIf="agendamentoObrigatorio">Obrigatório</span>
                  <small class="pay-schedule-hint">
                    {{ agendamentoObrigatorio ? 'Esta forma de entrega exige agendamento.' : 'Defina data e horário para envio mais tarde' }}
                  </small>
                </label>

                <div class="pay-schedule-fields" *ngIf="agendarEntrega">
                  <div class="pay-schedule-field" [class.is-invalid]="dataAgendamentoInvalida">
                    <span class="pay-schedule-label">Data</span>
                    <kendo-datepicker [ngModel]="dataAgendamento" (ngModelChange)="onDataAgendamentoChange($event)" [min]="agoraAgendamento" name="dataAgendamentoV3" class="pay-schedule-input">
                      <kendo-datepicker-messages today="Hoje" toggle="Trocar calendário"></kendo-datepicker-messages>
                    </kendo-datepicker>
                  </div>
                  <div class="pay-schedule-field" *ngIf="pedirHorarioAgendamento" [class.is-invalid]="horaAgendamentoInvalida">
                    <span class="pay-schedule-label">Hora</span>
                    <kendo-timepicker [ngModel]="horaAgendamento" (ngModelChange)="onHoraAgendamentoChange($event)" name="horaAgendamentoV3" class="pay-schedule-input">
                      <kendo-timepicker-messages accept="Ok" cancel="Cancelar" now="Agora" nowLabel="Agora"></kendo-timepicker-messages>
                    </kendo-timepicker>
                  </div>
                </div>
              </div>

              <div class="pay-obs-card">
                <p class="pay-section-kicker">Observações do pedido</p>
                <textarea class="pay-obs-textarea" [(ngModel)]="payObs" placeholder="Ex: Cliente vai precisar de nota fiscal, observações sobre entrega..." rows="2"></textarea>
              </div>
            </div>

            <div class="pay-col-side">
              <div class="pay-summary">
                <p class="pay-section-kicker">Resumo do Pedido</p>
                <div class="ps-row">
                  <span>Subtotal ({{ cart.length }} {{ cart.length === 1 ? 'item' : 'itens' }})</span>
                  <span class="ps-value">{{ formatCurrency(cartSubtotal) }}</span>
                </div>
                <div class="ps-row ps-row-fee" *ngIf="isDeliveryMode && deliveryFee">
                  <span>Taxa de entrega</span>
                  <span class="ps-value">{{ formatCurrency(+(deliveryFee) || 0) }}</span>
                </div>
                <div class="ps-row ps-row-discount">
                  <span>Descontos</span>
                  <span class="ps-value">- {{ formatCurrency(payDiscountVal) }}</span>
                </div>
                <div class="ps-row ps-row-cashback" *ngIf="cashbackAppliedValue > 0">
                  <span>Cashback</span>
                  <span class="ps-value">- {{ formatCurrency(cashbackAppliedValue) }}</span>
                </div>
                <div class="ps-divider"></div>
                <div class="ps-total-row">
                  <span>Total a pagar</span>
                  <span>{{ formatCurrency(payFinalTotal) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pay-footer">
        <div class="pay-shell">
          <button class="pay-cta"
                  [style.background]="canConfirmPaymentFlow ? 'linear-gradient(135deg,#16a34a,#22c55e)' : tc.gradient"
                  [disabled]="salvando"
                  (click)="handlePayCTA()">
            <span *ngIf="!salvando">{{ payCtaLabel }}</span>
            <span *ngIf="salvando">Salvando...</span>
            <span class="kbd-badge" *ngIf="!isMobile && canConfirmPaymentFlow">Enter</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  </ng-template>
</div>

<!-- ============================================ -->
<!-- TELA PDV — Layout Mobile                     -->
<!-- ============================================ -->
<div class="pdv-root" *ngIf="isMobile">
  <div class="m-pdv">
    <!-- Header mobile -->
    <div class="m-header">
      <button type="button" class="m-back-page" (click)="goBack()">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>
        <span>Voltar</span>
      </button>
      <button class="m-back" (click)="startNewOrder()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>
      </button>
      <div class="cart-badge" [style.background]="tc.tint" [style.color]="tc.primary">{{ tc.label }}</div>
    </div>

    <div class="m-top-context" *ngIf="orderType === 'mesa'">
      <div class="ctx-mesa-highlight is-mobile">
        <div class="ctx-mesa-head">
          <span class="ctx-mesa-kicker">Mesa selecionada</span>
          <span class="ctx-mesa-number">Mesa {{ mesaNumeroDestaque }}</span>
        </div>
        <div class="ctx-mesa-meta" *ngIf="mesaComandaDestaque || mesaGarcomDestaque">
          <span class="ctx-mesa-chip" *ngIf="mesaComandaDestaque">Comanda {{ mesaComandaDestaque }}</span>
          <span class="ctx-mesa-chip" *ngIf="mesaGarcomDestaque">Garçom {{ mesaGarcomDestaque }}</span>
        </div>
      </div>
    </div>

    <!-- Categorias horizontal -->
    <div class="m-cats">
      <ng-container *ngIf="productsLoading; else mobileCatsReady">
        <div class="m-cat m-cat-skeleton" *ngFor="let sk of categoryLoadingSkeletons; let i = index">
          <span class="m-cat-skeleton-line skel-shimmer" [style.width.px]="58 + ((i % 3) * 22)"></span>
        </div>
      </ng-container>
      <ng-template #mobileCatsReady>
        <div class="m-cat" *ngFor="let cat of categoryList"
             [class.active]="activeCat === cat.nome"
             [style.borderColor]="activeCat === cat.nome ? cat.cor : 'transparent'"
             [style.background]="activeCat === cat.nome ? cat.fundo : '#fff'"
             (click)="selectCategory(cat)">
          <span [style.color]="activeCat === cat.nome ? cat.cor : '#64748b'">{{ cat.nome }}</span>
        </div>
      </ng-template>
    </div>

    <!-- Busca mobile -->
    <div class="m-search">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
      <input type="text" [(ngModel)]="search" placeholder="Buscar produto..." class="m-search-input">
    </div>
    <div class="m-loading-status" *ngIf="productsLoading">
      <div class="mpls-chip">
        <span class="mpls-dot"></span>
        Carregando os Produtos
      </div>
      <div class="mpls-track">
        <div class="mpls-track-fill"></div>
      </div>
    </div>

    <!-- Grid de produtos mobile -->
    <div class="m-prod-grid" [class.is-loading]="productsLoading">
      <ng-container *ngIf="productsLoading; else mProdGridReady">
        <div class="m-prod-loading-banner">
          <span class="mplb-pill skel-shimmer"></span>
          <span class="mplb-line skel-shimmer"></span>
        </div>
        <div class="m-prod-card m-prod-card-skeleton" *ngFor="let sk of productLoadingSkeletons; let i = index">
          <div class="mpcs-img skel-shimmer"></div>
          <div class="mpcs-line mpcs-line-lg skel-shimmer" [style.width.%]="78 - ((i % 2) * 10)"></div>
          <div class="mpcs-line mpcs-line-sm skel-shimmer" [style.width.%]="56 + ((i % 3) * 8)"></div>
          <div class="mpcs-bottom">
            <div class="mpcs-price skel-shimmer"></div>
          </div>
        </div>
      </ng-container>
      <ng-template #mProdGridReady>
        <div class="m-prod-card" *ngFor="let p of filteredProducts; trackBy: trackById"
             [class.is-selected]="selProduct?.id === p.id"
             [class.has-image]="showProductPhotos"
             (click)="addToCart(p)">
          <ng-container *ngIf="showProductPhotos">
            <div class="mpc-img-wrap" *ngIf="p._image">
              <img [src]="p._image" [alt]="p.nome" class="mpc-img" loading="lazy"
                   (error)="onProductImageError(p)">
            </div>
            <div class="mpc-img-placeholder" *ngIf="!p._image">
              <span class="mpc-img-emoji">🍽️</span>
            </div>
          </ng-container>
          <div class="mpc-body">
            <span class="mpc-name">{{ p.nome }}</span>
            <div class="mpc-bottom">
              <span class="mpc-price">{{ formatCurrency(getProductPrice(p)) }}</span>
            </div>
          </div>
        </div>
        <div class="prod-empty" *ngIf="filteredProducts.length === 0">
          <span>Nenhum produto encontrado</span>
        </div>
      </ng-template>
    </div>

    <!-- Barra flutuante do carrinho (mobile) -->
    <div class="m-float-bar" *ngIf="cart.length > 0 && !mCartOpen && !mCustomizeOpen && !payScreen"
         (click)="mCartOpen = true">
      <div class="mfb-left">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
        <span class="mfb-count">{{ cart.length }}</span>
      </div>
      <span class="mfb-total">{{ formatCurrency(cartTotal) }}</span>
      <span class="mfb-label">Ver Carrinho</span>
    </div>
  </div>

  <!-- ============================================ -->
  <!-- MOBILE — Cart Sheet (bottom sheet)           -->
  <!-- ============================================ -->
  <div class="m-overlay" *ngIf="mCartOpen" (click)="mCartOpen = false"></div>
  <div class="m-sheet" [class.open]="mCartOpen">
    <div class="ms-handle"></div>
    <div class="ms-header">
      <span class="ms-title">Carrinho ({{ cart.length }})</span>
      <button class="ms-close" (click)="mCartOpen = false">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#64748b" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
    </div>

    <!-- Contexto (cliente/mesa) no mobile -->
    <div class="ms-context" *ngIf="isBalcaoMode">
      <div class="ctx-balcao-input-wrapper is-mobile">
        <label class="ctx-balcao-label">Nome do cliente</label>
        <input
          type="text"
          class="ctx-balcao-input"
          [(ngModel)]="identificacaoBalcao"
          (blur)="onIdentificacaoBalcaoChange()"
          placeholder="Identificação para o pedido"
          maxlength="80"
          [disabled]="salvando">
      </div>
    </div>
    <div class="ms-context" *ngIf="isDeliveryMode">
      <div class="ctx-client" *ngIf="!selectedContact" (click)="openClientModal()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#64748b" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
        <span>Buscar cliente...</span>
      </div>
      <div class="ctx-client-sel" *ngIf="selectedContact" style="background: #f0fdf4; border-color: #bbf7d0">
        <div class="ctx-avatar" [style.background]="tc.gradient">{{ getClientInitial(selectedContact) }}</div>
        <span class="ctx-client-name">{{ selectedContact.nome }}</span>
        <button class="ctx-client-clear" (click)="clearClient()">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>
    </div>
    <div class="ms-context" *ngIf="orderType === 'mesa'">
      <div class="ctx-mesa-highlight is-mobile">
        <div class="ctx-mesa-head">
          <span class="ctx-mesa-kicker">Mesa selecionada</span>
          <span class="ctx-mesa-number">Mesa {{ mesaNumeroDestaque }}</span>
        </div>
        <div class="ctx-mesa-meta" *ngIf="mesaComandaDestaque || mesaGarcomDestaque">
          <span class="ctx-mesa-chip" *ngIf="mesaComandaDestaque">Comanda {{ mesaComandaDestaque }}</span>
          <span class="ctx-mesa-chip" *ngIf="mesaGarcomDestaque">Garçom {{ mesaGarcomDestaque }}</span>
        </div>
      </div>
      <input class="ctx-input" [(ngModel)]="tableNum" placeholder="Número da mesa">
    </div>

    <!-- Itens -->
    <div class="ms-items">
      <div class="cart-item"
           *ngFor="let item of cart; trackBy: trackById; let i = index"
           (click)="editCartItem(item)"
           [style.animationDelay]="(i * 0.03) + 's'">
        <div class="ci-top">
          <div class="ci-info">
            <span class="ci-name">{{ item.name }}</span>
            <span class="ci-extras" *ngIf="getExtrasText(item)">{{ getExtrasText(item) }}</span>
          </div>
          <span class="ci-price">{{ formatCurrency(item.total) }}</span>
        </div>
        <div class="ci-bottom">
          <div class="ci-qty" (click)="$event.stopPropagation()">
            <button type="button"
                    class="ci-qty-btn ci-qty-btn-minus"
                    (click)="updateCartQty(item, -1)"
                    [disabled]="isCartQtyDecreaseDisabled(item)">−</button>
            <span class="ci-qty-val" [class.is-weight]="isCartItemByWeight(item)">{{ getCartQuantityLabel(item) }}</span>
            <button type="button"
                    class="ci-qty-btn ci-qty-btn-plus"
                    (click)="updateCartQty(item, 1)">+</button>
          </div>
          <button type="button" class="ci-remove" (click)="removeCartItem(item); $event.stopPropagation()">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
          </button>
        </div>
      </div>
    </div>

    <div class="ms-footer">
      <div class="cf-total">
        <span>Total</span>
        <span class="cf-total-val">{{ formatCurrency(cartTotal) }}</span>
      </div>
      <button class="cf-btn" *ngIf="!payScreen"
              [style.background]="tc.gradient"
              [disabled]="cart.length === 0 || salvando"
              [class.is-loading]="isMesaSending"
              (click)="!salvando && handleFinalizeOrderAction()">{{ finalizeOrderButtonLabel }}</button>
    </div>
  </div>

  <!-- ============================================ -->
  <!-- MOBILE — Personalização (overlay/sheet)      -->
  <!-- ============================================ -->
  <div class="m-overlay" *ngIf="mCustomizeOpen && selProduct" (click)="closeCustomize()"></div>
  <div class="m-sheet m-sheet-full" [class.open]="mCustomizeOpen && selProduct">
    <div class="ms-handle"></div>
    <div class="ms-header">
      <span class="ms-title">Personalizar</span>
      <button class="ms-close" (click)="closeCustomize()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#64748b" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
    </div>

    <div class="ms-custom-body" *ngIf="selProduct">
      <div class="sb-product">
        <span class="sb-pname">{{ selProduct.nome }}</span>
        <span class="sb-pprice">
          {{ isSelectedWeightProduct() ? formatCurrency(getProductPrice(selProduct)) : formatCurrency(customizeTotal) }}
          <span class="sb-pprice-unit" *ngIf="isSelectedWeightProduct()">/{{ getWeightPriceUnitLabel(selProduct) }}</span>
        </span>
      </div>

      <div class="sb-qty-section" *ngIf="!isSelectedWeightProduct(); else mobileWeightSection">
        <div class="sb-qty-row">
          <label class="sb-label-main">Quantidade</label>
          <div class="sb-qty-selector">
            <button type="button" class="tbtn-circle" (click)="decreaseCustomizeQty()" [disabled]="isCustomizeQtyDecreaseDisabled()">−</button>
            <span class="sb-qty-num">{{ qty }}</span>
            <button type="button" class="tbtn-circle" (click)="increaseCustomizeQty()">+</button>
          </div>
        </div>
      </div>
      <ng-template #mobileWeightSection>
        <div class="sb-weight-section is-mobile">
          <div class="sb-weight-alert">
            <span class="sb-weight-alert-dot"></span>
            <div>
              <strong>Balança não conectada</strong>
              <span>Insira o peso do item manualmente para calcular o valor</span>
            </div>
            <i class="fa fa-info-circle" aria-hidden="true"></i>
          </div>
          <div class="sb-weight-grid">
            <div class="sb-weight-field">
              <label class="sb-label-main">Peso do item</label>
              <div class="sb-weight-input-row">
                <button type="button" class="tbtn-circle" (click)="changeWeightQuantity(-1)" [disabled]="isCustomizeQtyDecreaseDisabled()">−</button>
                <div class="sb-weight-input-wrap">
                  <input class="sb-weight-input"
                         type="number"
                         [ngModel]="qty"
                         (ngModelChange)="setWeightQuantity($event)"
                         [step]="getWeightIncrement(selProduct)"
                         [min]="getWeightMinimumInput(selProduct)"
                         [attr.max]="getWeightMaximumInput(selProduct)">
                  <span>{{ getWeightUnit(selProduct) }}</span>
                </div>
                <button type="button" class="tbtn-circle" (click)="changeWeightQuantity(1)">+</button>
              </div>
              <span class="sb-label-sub">Calculado automaticamente com base no peso por {{ getWeightUnit(selProduct) }}</span>
            </div>
            <div class="sb-weight-field">
              <label class="sb-label-main">Valor calculado</label>
              <div class="sb-weight-readonly">{{ formatCurrency(customizeTotal) }}</div>
            </div>
          </div>
        </div>
      </ng-template>

      <div class="sb-section"
           *ngFor="let field of selProductOrderedFields; trackBy: trackByFieldKey"
           [attr.data-field-key]="field.fieldKey"
           [attr.data-shake-key]="getFieldShakeKey(field)">
        <div class="sb-section-header">
          <div class="sb-section-title">
            <label class="sb-label-main">{{ field.name }}</label>
            <span class="sb-label-sub" *ngIf="field.kind === 'repeat'">Escolha a quantidade de cada</span>
            <span class="sb-label-sub" *ngIf="field.kind === 'multi'">Selecione as opções</span>
            <span class="sb-label-sub" *ngIf="field.kind === 'single'">Escolha 1 opção</span>
          </div>
          <div class="sb-header-meta">
            <span class="sb-required-badge" *ngIf="field.required || (field.min || 0) > 0">OBRIGATÓRIO</span>
            <span class="sb-counter" [class.active]="isFieldCounterActive(field)">
              {{ getFieldCounterText(field) }}
            </span>
          </div>
        </div>

        <ng-container [ngSwitch]="field.kind">
          <div class="sb-extras-list" *ngSwitchCase="'repeat'">
            <div class="sb-extra-item" *ngFor="let option of field.options; trackBy: trackByOptionKey"
                 [class.active]="getRepeatQty(field, option) > 0"
                 [class.error]="fieldHasError(field)">
              <div class="sb-extra-info">
                <span class="sb-extra-name">{{ option.name }}</span>
                <span class="sb-extra-badge" *ngIf="option.price > 0">+{{ formatCurrency(option.price) }}</span>
              </div>
              <div class="sb-extra-controls">
                <button type="button" class="tbtn-xs" (click)="changeRepeatQty(field, option, -1); $event.stopPropagation()"
                        [disabled]="getRepeatQty(field, option) <= 0">−</button>
                <span class="sb-extra-qty-num">{{ getRepeatQty(field, option) }}</span>
                <button type="button" class="tbtn-xs" (click)="changeRepeatQty(field, option, 1); $event.stopPropagation()">+</button>
              </div>
            </div>
          </div>

          <div class="sb-choice-list" *ngSwitchCase="'multi'">
            <button type="button" class="sb-choice-item" *ngFor="let option of field.options; trackBy: trackByOptionKey"
                    [class.active]="isMultiSelected(field, option)"
                    [class.error]="fieldHasError(field)"
                    (click)="toggleMultiChoice(field, option)">
              <span class="sb-choice-check">
                <svg *ngIf="isMultiSelected(field, option)" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </span>
              <span class="sb-choice-name">{{ option.name }}</span>
              <span class="sb-choice-badge" *ngIf="option.price > 0">+{{ formatCurrency(option.price) }}</span>
            </button>
          </div>

          <div class="sb-radio-row" *ngSwitchDefault>
            <div class="sb-radio-card" *ngFor="let option of field.options; trackBy: trackByOptionKey"
                 [class.active]="isSingleSelected(field, option)"
                 [class.error]="fieldHasError(field)"
                 (click)="selectSingleChoice(field, option)">
              <div class="sb-radio-circle"></div>
              <span class="sb-radio-label">{{ option.name }}</span>
              <span class="sb-radio-price" *ngIf="option.price > 0">+{{ formatCurrency(option.price) }}</span>
            </div>
          </div>
        </ng-container>

        <div class="sb-error" *ngIf="fieldHasError(field)">{{ fieldErrorText(field) }}</div>
      </div>

      <div class="sb-section">
        <label class="sb-label-main">Desconto</label>
        <div class="sb-input-wrapper">
          <span class="sb-input-prefix">R$</span>
          <input class="sb-input-field" [(ngModel)]="discount" placeholder="0,00" type="text">
        </div>
      </div>

      <div class="sb-section">
        <label class="sb-label-main">Observação</label>
        <textarea class="sb-textarea" [(ngModel)]="obs" placeholder="Ex: sem calda, bem gelado..." rows="2"></textarea>
      </div>
    </div>

    <div class="sb-footer" *ngIf="selProduct">
      <div class="sb-total">
        <span>Total</span>
        <span class="sb-total-val">{{ formatCurrency(customizeTotal) }}</span>
      </div>
      <button class="sb-add-btn" (click)="confirmCustomize()">{{ editingItem ? 'Salvar Alteração' : 'Adicionar ao Pedido' }}</button>
    </div>
  </div>

  <!-- ============================================ -->
  <!-- MOBILE — Pagamento (overlay full)            -->
  <!-- ============================================ -->
  <div class="m-pay-overlay" *ngIf="payScreen">
    <div class="m-pay-header">
      <button class="m-back" (click)="closePayScreen()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>
      </button>
      <div class="pay-title-group pay-title-group-mobile">
        <span class="m-pay-title">Pagamento</span>
        <span class="pay-subtitle">{{ cart.length }} {{ cart.length === 1 ? 'item' : 'itens' }} no pedido</span>
      </div>
      <div class="pay-total-display pay-total-display-mobile">
        <span class="pay-total-label">Total</span>
        <span class="pay-total-value">{{ formatCurrency(payFinalTotal) }}</span>
      </div>
    </div>

    <div class="m-pay-body">
      <div class="m-pay-client-context"
           *ngIf="orderType === 'delivery'"
           [class.is-empty]="!selectedContact">
        <div class="m-pay-client-head">
          <span class="m-pay-client-title">Cliente do pedido</span>
          <span class="m-pay-client-badge" [class.is-required]="isDeliveryMode">
            {{ isDeliveryMode ? 'Obrigatório' : 'Recomendado' }}
          </span>
        </div>
        <p class="m-pay-client-hint" *ngIf="!selectedContact">
          {{ isDeliveryMode
            ? 'Selecione o cliente e o endereço antes de confirmar o pedido.'
            : 'Selecione o cliente para identificar e consultar histórico do pedido.' }}
        </p>
        <div class="ctx-client-btn" *ngIf="!selectedContact" (click)="openClientModal()">
          <svg class="ctx-icon-left" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#64748b" stroke-width="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
          <span class="ctx-btn-text">{{ isDeliveryMode ? 'Selecionar cliente e endereço' : 'Selecionar cliente (opcional)' }}</span>
          <span class="kbd-badge is-light">F4</span>
          <svg class="ctx-icon-right" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="2">
            <circle cx="11" cy="11" r="8"/>
            <line x1="21" y1="21" x2="16.65" y2="16.65"/>
          </svg>
        </div>

        <div class="ctx-client-sel ctx-client-sel-customer" *ngIf="selectedContact" (click)="openClientModal()">
          <div class="ctx-avatar" [style.background]="tc.gradient">{{ getClientInitial(selectedContact) }}</div>
          <div class="ctx-client-main">
            <span class="ctx-client-name">{{ selectedContact.nome }}</span>
            <span class="ctx-client-phone-row" *ngIf="customerPhone || selectedContact?.telefone">
              <svg class="ctx-client-phone-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#64748b" stroke-width="2">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.9.34 1.78.65 2.62a2 2 0 0 1-.45 2.11L8.04 9.96a16 16 0 0 0 6 6l1.51-1.27a2 2 0 0 1 2.11-.45c.84.31 1.72.53 2.62.65A2 2 0 0 1 22 16.92z"/>
              </svg>
              <span class="ctx-client-phone">{{ selectedContact?.telefone ? (selectedContact.telefone | tel:selectedContact?.codigoPais) : customerPhone }}</span>
            </span>
            <span class="ctx-client-address-row" *ngIf="isDeliveryMode && (selectedAddress ? getClientAddressFull(selectedAddress) : customerAddress) as payClientAddress">
              <svg class="ctx-client-address-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
              </svg>
              <span class="ctx-client-address-copy">
                <span class="ctx-client-address-label">Endereço</span>
                <span class="ctx-client-address-text">{{ payClientAddress }}</span>
              </span>
            </span>
            <button type="button"
                    class="ctx-client-change-action"
                    (click)="abraTrocaClientePedido($event)">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 20h9"/>
                <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"/>
              </svg>
              <span>Trocar cliente</span>
              <span class="kbd-badge is-light">F4</span>
            </button>
          </div>
          <button class="ctx-client-clear" (click)="clearClient(); $event.stopPropagation()">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
        <p class="m-pay-client-hint m-pay-client-hint-error"
           *ngIf="shouldShowMissingDeliveryAddressAlert">
          {{ selectedContact?.id
            ? 'Selecione um endereço para confirmar o pedido de entrega.'
            : 'Selecione cliente e endereço para confirmar o pedido de entrega.' }}
        </p>
      </div>

      <div class="pay-stack pay-stack-mobile">
        <div class="pay-summary">
          <p class="pay-section-kicker">Resumo do Pedido</p>
          <div class="ps-row">
            <span>Subtotal ({{ cart.length }} {{ cart.length === 1 ? 'item' : 'itens' }})</span>
            <span class="ps-value">{{ formatCurrency(cartSubtotal) }}</span>
          </div>
          <div class="ps-row ps-row-fee" *ngIf="isDeliveryMode && deliveryFee">
            <span>Taxa de entrega</span>
            <span class="ps-value">{{ formatCurrency(+(deliveryFee) || 0) }}</span>
          </div>
          <div class="ps-row ps-row-discount">
            <span>Descontos</span>
            <span class="ps-value">- {{ formatCurrency(payDiscountVal) }}</span>
          </div>
          <div class="ps-row ps-row-cashback" *ngIf="cashbackAppliedValue > 0">
            <span>Cashback</span>
            <span class="ps-value">- {{ formatCurrency(cashbackAppliedValue) }}</span>
          </div>
          <div class="ps-divider"></div>
          <div class="ps-total-row">
            <span>Total a pagar</span>
            <span>{{ formatCurrency(payFinalTotal) }}</span>
          </div>
        </div>

        <div class="pay-discount-section">
          <p class="pay-section-kicker">Descontos e Benefícios</p>
          <div class="pd-main-row">
            <div class="pd-input-group">
              <div class="pd-toggle-wrap">
                <button class="pd-toggle"
                        [style.background]="payDiscountType === 'R$' ? '#6366f1' : '#f8fafc'"
                        [style.color]="payDiscountType === 'R$' ? '#fff' : '#64748b'"
                        (click)="payDiscountType = 'R$'">R$</button>
                <button class="pd-toggle"
                        [style.background]="payDiscountType === '%' ? '#6366f1' : '#f8fafc'"
                        [style.color]="payDiscountType === '%' ? '#fff' : '#64748b'"
                        (click)="payDiscountType = '%'">%</button>
              </div>
              <input class="pd-input pd-input-discount" [(ngModel)]="payDiscount" placeholder="0,00" type="number">
            </div>
          </div>
          <div class="pd-cupom-row">
            <div class="pd-cupom-wrap">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="2"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
              <input class="pd-input pd-cupom" [(ngModel)]="payCupom" placeholder="Código do cupom">
            </div>
            <button class="pd-apply-btn" type="button">Aplicar</button>
          </div>
        </div>

        <div class="pay-cashback-card" *ngIf="showCashbackPanel">
          <div class="pcb-head">
            <div class="pcb-title-wrap">
              <span class="pcb-title">Cashback</span>
              <span class="pcb-badge">Saldo disponível</span>
            </div>
            <span class="pcb-balance">{{ formatCurrency(cashbackAvailableAmount) }}</span>
          </div>

          <p class="pcb-hint" *ngIf="!hasCashbackPaymentMethodConfigured">
            Habilite a forma de pagamento em cashback para usar o saldo neste pedido.
          </p>

          <div class="pcb-actions" *ngIf="hasCashbackPaymentMethodConfigured && !usarSaldoCashback">
            <button type="button" class="pcb-btn" (click)="activateCashbackUsage()">Usar saldo</button>
          </div>

          <div class="pcb-editor" *ngIf="hasCashbackPaymentMethodConfigured && usarSaldoCashback">
            <label class="pcb-label">Quanto do cashback vai usar?</label>
            <div class="pcb-input-row">
              <span class="pcb-curr">R$</span>
              <input class="pcb-input"
                     type="number"
                     step="0.01"
                     min="0"
                     [max]="cashbackMaxUsable"
                     [(ngModel)]="cashbackState.valor"
                     (ngModelChange)="onCashbackValueChange()">
              <button type="button" class="pcb-remove" (click)="disableCashbackUsage()">Remover</button>
            </div>
            <div class="pcb-meta">
              <span>Máximo: {{ formatCurrency(cashbackMaxUsable) }}</span>
              <span *ngIf="cashbackAppliedValue > 0">Aplicado: {{ formatCurrency(cashbackAppliedValue) }}</span>
            </div>
          </div>
        </div>

        <div class="pay-methods-panel">
          <p class="pay-section-kicker">{{ isSplit ? 'Divisão do pagamento' : 'Forma de pagamento' }}</p>

          <div class="pay-methods-selected" *ngIf="isSplit">
            <div class="pms-card"
                 *ngFor="let pm of payMethods; let i = index; trackBy: trackBySelectedPayMethod"
                 [class.compact]="isCompact"
                 [class.is-rest]="i === restanteIdx"
                 [style.borderColor]="i === restanteIdx ? '#6366f1' : (pm.color + '30')">
              <div class="pms-top" [class.is-rest]="i === restanteIdx" [style.background]="i === restanteIdx ? '#eef2ff' : (pm.color + '06')">
                <div class="pms-info">
                  <div class="pms-icon-circle" [style.background]="i === restanteIdx ? '#6366f120' : (pm.color + '15')">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" [attr.stroke]="i === restanteIdx ? '#6366f1' : pm.color" stroke-width="2">
                      <rect *ngIf="pm.icon==='card'" x="1" y="4" width="22" height="16" rx="2" ry="2"/><line *ngIf="pm.icon==='card'" x1="1" y1="10" x2="23" y2="10"/>
                      <rect *ngIf="pm.icon==='banknote'" x="2" y="6" width="20" height="12" rx="2"/><circle *ngIf="pm.icon==='banknote'" cx="12" cy="12" r="2"/>
                      <rect *ngIf="pm.icon==='qr'" x="3" y="3" width="7" height="7"/><rect *ngIf="pm.icon==='qr'" x="14" y="3" width="7" height="7"/><rect *ngIf="pm.icon==='qr'" x="3" y="14" width="7" height="7"/>
                      <rect *ngIf="pm.icon==='wallet'" x="2" y="5" width="20" height="14" rx="2"/><path *ngIf="pm.icon==='wallet'" d="M16 12h2"/>
                    </svg>
                  </div>
                  <span class="pms-name" [style.color]="i === restanteIdx ? '#6366f1' : pm.color">
                    {{ pm.name }}
                    <span *ngIf="pm.original?.fiado === true" class="pg-fiado-badge">Fiado</span>
                  </span>
                  <span class="pms-restante-badge" *ngIf="i === restanteIdx">Restante</span>
                </div>
                <button class="pms-remove-x" (click)="removePayMethod(pm.id)">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#dc2626" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                </button>
              </div>
              <div class="pms-amount">
                <span class="pms-curr">R$</span>
                <input class="pms-amount-input"
                       [class.is-rest]="i === restanteIdx"
                       [(ngModel)]="pm.amount"
                       type="number"
                       step="0.01"
                       (ngModelChange)="onPayAmountChange(i)">
              </div>
            </div>

            <div class="split-status">
              <div class="ss-bar ss-warning" *ngIf="splitHasEmpty">
                Digite um valor na forma adicionada ou remova-a.
              </div>
              <div class="ss-bar ss-error" *ngIf="!splitHasEmpty && splitOverflow">
                Soma excede o total em {{ formatCurrency(payPaidTotal - payFinalTotal) }}
              </div>
              <div class="ss-bar ss-warning" *ngIf="!splitHasEmpty && !splitOverflow && payRemaining > 0">
                Faltam {{ formatCurrency(payRemaining) }}
              </div>
              <div class="ss-bar ss-success" *ngIf="!splitHasEmpty && !splitOverflow && payRemaining === 0">
                <span>Total: <b>{{ formatCurrency(payFinalTotal) }}</b></span>
                <span>✓ Divisão fechada</span>
              </div>
            </div>

            <button class="pay-add-method" (click)="openAddPayMethod()" *ngIf="!showPayGrid">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#6366f1" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
              Adicionar forma
            </button>
          </div>

          <div class="pay-method-single" *ngIf="payMethods.length === 1">
            <div class="pms-single-card"
                 [style.borderColor]="payMethods[0].color"
                 [style.background]="payMethods[0].color + '06'">
              <div class="pms-info">
                <div class="pms-icon-circle" [style.background]="payMethods[0].color + '15'">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" [attr.stroke]="payMethods[0].color" stroke-width="2">
                    <rect *ngIf="payMethods[0].icon==='card'" x="1" y="4" width="22" height="16" rx="2" ry="2"/><line *ngIf="payMethods[0].icon==='card'" x1="1" y1="10" x2="23" y2="10"/>
                    <rect *ngIf="payMethods[0].icon==='banknote'" x="2" y="6" width="20" height="12" rx="2"/><circle *ngIf="payMethods[0].icon==='banknote'" cx="12" cy="12" r="2"/>
                    <rect *ngIf="payMethods[0].icon==='qr'" x="3" y="3" width="7" height="7"/><rect *ngIf="payMethods[0].icon==='qr'" x="14" y="3" width="7" height="7"/><rect *ngIf="payMethods[0].icon==='qr'" x="3" y="14" width="7" height="7"/>
                    <rect *ngIf="payMethods[0].icon==='wallet'" x="2" y="5" width="20" height="14" rx="2"/><path *ngIf="payMethods[0].icon==='wallet'" d="M16 12h2"/>
                  </svg>
                </div>
                <div class="pms-text">
                  <span class="pms-name" [style.color]="payMethods[0].color">
                    {{ payMethods[0].name }}
                    <span *ngIf="payMethods[0].original?.fiado === true" class="pg-fiado-badge">Fiado</span>
                  </span>
                  <span class="pms-desc" *ngIf="payMethods[0].desc">{{ payMethods[0].desc }}</span>
                </div>
              </div>
              <span class="pms-single-amount">{{ formatCurrency(payMethods[0].amount || 0) }}</span>
              <button class="pms-remove-x" (click)="removePayMethod(payMethods[0].id)">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#dc2626" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>

            <div class="pay-troco pay-troco-inline" *ngIf="hasDinheiro">
              <div class="pt-header">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2"><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="2"/></svg>
                <label>Troco para</label>
              </div>
              <div class="pt-input-group">
                <span class="pt-curr">R$</span>
                <input class="pt-input" [(ngModel)]="payTroco" placeholder="0,00" type="number">
              </div>
              <div class="pt-result" *ngIf="trocoValue > 0">Troco: <strong>{{ formatCurrency(trocoValue) }}</strong></div>
            </div>

            <button class="pay-add-inline" (click)="openAddPayMethod()" *ngIf="!showPayGrid">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#6366f1" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
              Adicionar outra forma (dividir pagamento)
            </button>
          </div>

          <div class="pay-troco" *ngIf="isSplit && hasDinheiro">
            <div class="pt-header">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2"><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="2"/></svg>
              <label>Troco para</label>
            </div>
            <div class="pt-input-group">
              <span class="pt-curr">R$</span>
              <input class="pt-input" [(ngModel)]="payTroco" placeholder="0,00" type="number">
            </div>
            <div class="pt-result" *ngIf="trocoValue > 0">Troco: <strong>{{ formatCurrency(trocoValue) }}</strong></div>
          </div>

          <div class="pay-grid" id="payGrid" *ngIf="payMethods.length === 0 || showPayGrid">
            <div class="pg-divider" *ngIf="payMethods.length > 0 && payMethodSectionsView.length > 0">Selecione</div>

            <div class="pg-empty" *ngIf="payMethodSectionsView.length === 0">
              Nenhuma forma de pagamento disponível para este tipo de pedido.
            </div>

            <div class="pg-section" *ngFor="let section of payMethodSectionsView; trackBy: trackByPaySection">
              <div class="pg-section-header">
                <span class="pg-section-title">{{ section.title }}</span>
                <span class="pg-section-badge"
                      [style.background]="section.badgeColor + '15'"
                      [style.color]="section.badgeColor">{{ section.badge }}</span>
              </div>

              <div class="pg-cards">
                <button type="button"
                        class="pg-card"
                        *ngFor="let m of section.methods; trackBy: trackByPayMethod"
                        (click)="selectPayMethod(m)"
                        [attr.aria-label]="'Selecionar forma de pagamento ' + m.name">
                  <div class="pms-icon-circle pg-card-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="2">
                      <rect *ngIf="m.icon==='card'" x="1" y="4" width="22" height="16" rx="2" ry="2"/><line *ngIf="m.icon==='card'" x1="1" y1="10" x2="23" y2="10"/>
                      <rect *ngIf="m.icon==='banknote'" x="2" y="6" width="20" height="12" rx="2"/><circle *ngIf="m.icon==='banknote'" cx="12" cy="12" r="2"/>
                      <rect *ngIf="m.icon==='qr'" x="3" y="3" width="7" height="7"/><rect *ngIf="m.icon==='qr'" x="14" y="3" width="7" height="7"/><rect *ngIf="m.icon==='qr'" x="3" y="14" width="7" height="7"/>
                      <rect *ngIf="m.icon==='wallet'" x="2" y="5" width="20" height="14" rx="2"/><path *ngIf="m.icon==='wallet'" d="M16 12h2"/>
                    </svg>
                  </div>
                  <div class="pg-card-info">
                    <span class="pg-card-name">
                      {{ m.name }}
                      <span *ngIf="m.original?.fiado === true" class="pg-fiado-badge">Fiado</span>
                    </span>
                    <span class="pg-card-desc" *ngIf="m.desc">{{ m.desc }}</span>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="pay-paid-card" *ngIf="orderType !== 'mesa'">
          <label class="pay-paid-toggle" [class.is-disabled]="!canMarkOrderPaidOnCreate">
            <input type="checkbox"
                   [checked]="marcarPedidoComoPago"
                   [disabled]="!canMarkOrderPaidOnCreate"
                   (change)="toggleMarkOrderPaid($any($event.target).checked)">
            <span class="pay-section-kicker">Marcar pedido como pago</span>
            <small class="pay-paid-hint" *ngIf="isBalcaoMode && canMarkOrderPaidOnCreate">
              Pedidos de balcão já ficam desmarcados por padrão.
            </small>
            <small class="pay-paid-hint" *ngIf="!canMarkOrderPaidOnCreate">
              Disponível apenas para pagamento presencial, sem fiado.
            </small>
          </label>
        </div>

        <div class="pay-schedule-card" *ngIf="permiteAgendamentoPedido">
          <label class="pay-schedule-toggle" [class.is-required]="agendamentoObrigatorio">
            <input type="checkbox"
                   [checked]="agendarEntrega"
                   [disabled]="agendamentoObrigatorio"
                   (change)="onToggleAgendarEntrega($any($event.target).checked)">
            <span class="pay-section-kicker">Agendar pedido</span>
            <span class="pay-schedule-badge" *ngIf="agendamentoObrigatorio">Obrigatório</span>
            <small class="pay-schedule-hint">
              {{ agendamentoObrigatorio ? 'Esta forma de entrega exige agendamento.' : 'Defina data e horário para envio mais tarde' }}
            </small>
          </label>

          <div class="pay-schedule-fields" *ngIf="agendarEntrega">
            <div class="pay-schedule-field" [class.is-invalid]="dataAgendamentoInvalida">
              <span class="pay-schedule-label">Data</span>
              <kendo-datepicker [ngModel]="dataAgendamento" (ngModelChange)="onDataAgendamentoChange($event)" [min]="agoraAgendamento" name="dataAgendamentoV3Mobile" class="pay-schedule-input">
                <kendo-datepicker-messages today="Hoje" toggle="Trocar calendário"></kendo-datepicker-messages>
              </kendo-datepicker>
            </div>
            <div class="pay-schedule-field" *ngIf="pedirHorarioAgendamento" [class.is-invalid]="horaAgendamentoInvalida">
              <span class="pay-schedule-label">Hora</span>
              <kendo-timepicker [ngModel]="horaAgendamento" (ngModelChange)="onHoraAgendamentoChange($event)" name="horaAgendamentoV3Mobile" class="pay-schedule-input">
                <kendo-timepicker-messages accept="Ok" cancel="Cancelar" now="Agora" nowLabel="Agora"></kendo-timepicker-messages>
              </kendo-timepicker>
            </div>
          </div>
        </div>

        <div class="pay-obs-card">
          <p class="pay-section-kicker">Observações do pedido</p>
          <textarea class="pay-obs-textarea" [(ngModel)]="payObs" placeholder="Ex: Cliente vai precisar de nota fiscal, observações sobre entrega..." rows="2"></textarea>
        </div>
      </div>
    </div>

    <div class="m-pay-footer">
      <button class="pay-cta"
              [style.background]="canConfirmPaymentFlow ? 'linear-gradient(135deg,#16a34a,#22c55e)' : tc.gradient"
              [disabled]="salvando" (click)="handlePayCTA()">
        <span *ngIf="!salvando">{{ payCtaLabel }}</span>
        <span *ngIf="salvando">Salvando...</span>
      </button>
    </div>
  </div>
</div>

<!-- ============================================ -->
<!-- MODAL — Seleção de Cliente                   -->
<!-- ============================================ -->
<app-central-pedidos-dialog
  *ngIf="centralPedidosAtivo"
  [aberto]="centralPedidosDialogAberto"
  [termoBusca]="centralPedidosBusca"
  [buscaExecutada]="centralPedidosBuscaExecutada"
  [buscando]="centralPedidosBuscando"
  [modoTrocaCliente]="centralPedidosModoTrocaCliente"
  [criandoCliente]="centralPedidosCriandoCliente"
  [erro]="centralPedidosErro"
  [clientesAgrupados]="centralPedidosClientesAgrupados"
  [clienteSelecionado]="centralPedidosClienteSelecionado"
  [enderecos]="centralPedidosEnderecos"
  [enderecoSelecionado]="centralPedidosEnderecoSelecionado"
  [preparando]="centralPedidosPreparando"
  [lojaDestino]="centralPedidosLojaDestino"
  [roteamento]="centralPedidosRoteamento"
  [lojasParticipantes]="centralPedidosLojasParaDialog"
  (fechar)="fecheDialogCentralPedidos()"
  (buscar)="busqueClientesCentralPedidos()"
  (alterarTermoBusca)="atualizeBuscaCentralPedidos($event)"
  (criarCliente)="crieClienteCentralPedidos($event)"
  (selecionarCliente)="selecioneClienteCentralPedidos($event)"
  (trocarCliente)="troqueClienteCentralPedidos()"
  (selecionarEndereco)="selecioneEnderecoCentralPedidos($event)"
  (selecionarLojaSemEndereco)="selecioneLojaManualCentralPedidos($event)"
  (cadastrarEndereco)="cadastreEnderecoCentralPedidos($event)"
  (continuarRetiradaDestino)="continueRetiradaDestinoCentralPedidos()">
</app-central-pedidos-dialog>

<div class="central-lojas-backdrop" *ngIf="centralPedidosLojasDialogAberto" (click)="fecheDialogLojasCentralPedidos()"></div>
<section class="central-lojas-dialog"
         *ngIf="centralPedidosLojasDialogAberto"
         role="dialog"
         aria-modal="true"
         aria-label="Escolher loja da Central">
  <div class="central-lojas-head">
    <div>
      <span>Atendimento por loja</span>
      <h2>Escolha uma unidade</h2>
      <p>
        Use quando o cliente pedir uma unidade específica ou para abrir o atendimento sem identificar o cliente agora.
      </p>
    </div>
    <button type="button" class="central-lojas-close" (click)="fecheDialogLojasCentralPedidos()">
      <span>ESC</span>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18"/>
        <line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </button>
  </div>

  <div class="central-lojas-list" *ngIf="centralPedidosLojasOrdenadas.length; else centralLojasVazio">
    <button type="button"
            class="central-store-card"
            *ngFor="let loja of centralPedidosLojasOrdenadas"
            [class.is-selected]="isLojaCentralSelecionada(loja)"
            [class.has-delivery]="lojaCentralTemDelivery(loja)"
            (click)="selecioneLojaManualCentralPedidos(loja)"
            [disabled]="!centralPedidosPodeOperar || centralPedidosPreparando">
      <span class="central-store-icon" [class.is-delivery]="lojaCentralTemDelivery(loja)">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M4 10h16l-2-6H6l-2 6Z"/>
          <path d="M6 10v10h12V10"/>
          <path d="M10 20v-6h4v6"/>
          <path d="M4 10c0 2 1.5 3 3 3s3-1 3-3c0 2 1.5 3 3 3s3-1 3-3c0 2 1.5 3 3 3s3-1 3-3"/>
        </svg>
      </span>
      <div class="central-store-info">
        <strong class="central-loja-nome">
          <ng-container *ngIf="getNomeLojaPartes(loja) as partes">
            <span class="central-loja-nome-comum" *ngIf="partes.prefixo">{{ partes.prefixo }}</span><span class="central-loja-nome-distintivo">{{ partes.destaque }}</span><span class="central-loja-nome-comum" *ngIf="partes.sufixo">{{ partes.sufixo }}</span>
          </ng-container>
        </strong>
        <div class="central-store-capacities">
          <span class="central-store-cap is-delivery" *ngIf="lojaCentralTemDelivery(loja)">
            <i></i>Delivery
          </span>
          <span class="central-store-cap is-retirada" *ngIf="lojaCentralTemRetirada(loja)">
            <i></i>Retirada
          </span>
          <span class="central-store-cap is-none" *ngIf="!lojaCentralTemDelivery(loja) && !lojaCentralTemRetirada(loja)">
            Sem modalidade configurada
          </span>
        </div>
      </div>
      <em class="is-selected" *ngIf="isLojaCentralSelecionada(loja)">Selecionada</em>
    </button>
  </div>

  <ng-template #centralLojasVazio>
    <div class="central-empty-stores">Nenhuma loja participante configurada.</div>
  </ng-template>
</section>

<div class="modal-backdrop" *ngIf="showClientModal" (click)="closeClientModal()"></div>
<div class="modal-client" *ngIf="showClientModal">
  <div class="mc-header">
    <div class="mc-header-top">
      <span class="mc-modal-title">{{ clientModalAddressOnly ? 'Trocar endereço' : 'Seleção de cliente' }}</span>
      <div class="mc-header-actions">
        <button type="button" class="mc-no-client-btn" *ngIf="!clientModalAddressOnly" (click)="selectNoClient()">Sem cliente</button>
        <button type="button" class="mc-close" (click)="closeClientModal()">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>
    </div>

    <div class="mc-search" *ngIf="!clientModalAddressOnly">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
      <input class="mc-search-input" [(ngModel)]="clientSearch" (ngModelChange)="searchClients($event)"
             placeholder="Buscar por nome ou telefone..." appAutoFocus>
    </div>
  </div>

  <div class="mc-results">
    <div class="mc-empty" *ngIf="clientSearch.length >= 2 && clientSearchLoading && clientResults.length === 0">
      Buscando clientes...
    </div>

    <div class="mc-empty" *ngIf="clientSearch.length >= 2 && !clientSearchLoading && clientSearchError">
      Erro ao buscar clientes. Tente novamente.
    </div>

    <div class="mc-empty" *ngIf="clientSearch.length >= 2 && !clientSearchLoading && !clientSearchError && clientResults.length === 0">
      Nenhum cliente encontrado
    </div>

    <div class="mc-client" *ngFor="let c of clientResults; trackBy: trackById">
      <div class="mc-client-row"
           [class.is-expanded]="expandedClientId === c.id"
           [class.is-selected]="selectedContact?.id === c.id"
           (click)="toggleClientExpand(c)">
        <div class="mc-avatar">{{ getClientInitial(c) }}</div>
        <div class="mc-client-info">
          <div class="mc-client-title-row">
            <span class="mc-client-name">{{ c.nome }}</span>
            <span class="mc-client-status"
                  *ngIf="getClientStatusLabel(c)"
                  [class.is-active]="isClientStatusActive(c)">
              {{ getClientStatusLabel(c) }}
            </span>
          </div>
          <span class="mc-client-phone">{{ c.telefone | tel:c.codigoPais }}</span>
          <span class="mc-client-address-count" *ngIf="c._loaded && getClientAddressCount(c) > 0">
            {{ getClientAddressCount(c) }} endereço{{ getClientAddressCount(c) > 1 ? 's' : '' }} cadastrado{{ getClientAddressCount(c) > 1 ? 's' : '' }}
          </span>
        </div>
        <span class="mc-client-chevron"
              *ngIf="canExpandClientAddresses(c)"
              [class.is-expanded]="expandedClientId === c.id">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="2">
            <polyline points="6 9 12 15 18 9"/>
          </svg>
        </span>
      </div>

      <div class="mc-addresses-actions" *ngIf="expandedClientId === c.id">
        <button type="button"
                class="mc-addr-selectless"
                *ngIf="canSelectClientWithoutAddress()"
                (click)="selectClientWithoutAddress(c, $event)">
          Selecionar para retirada
        </button>
        <button type="button"
                class="mc-addr-create"
                (click)="openCreateClientAddressModal(c, $event)">
          Cadastrar endereço
        </button>
      </div>

      <!-- Endereços expandidos -->
      <div class="mc-addresses mc-addresses-state" *ngIf="expandedClientId === c.id && c._loadingDetails">
        <div class="mc-addr-state-card is-loading">
          <div class="mc-addr-loading-row">
            <span class="mc-addr-loading-dot"></span>
            <span class="mc-addr-loading-text">Carregando endereços...</span>
          </div>
          <span class="mc-addr-skel-line skel-shimmer"></span>
          <span class="mc-addr-skel-line mc-addr-skel-line-sm skel-shimmer"></span>
        </div>
      </div>

      <div class="mc-addresses mc-addresses-state" *ngIf="expandedClientId === c.id && !c._loadingDetails && c._loadError">
        <div class="mc-addr-state-card is-error">
          <span class="mc-addr-state-title">Erro ao carregar endereços</span>
          <span class="mc-addr-state-sub">Tente novamente para buscar os endereços deste cliente.</span>
          <button type="button" class="mc-addr-retry" (click)="retryClientDetails(c, $event)">Tentar novamente</button>
        </div>
      </div>

      <div class="mc-addresses" *ngIf="expandedClientId === c.id && !c._loadingDetails && !c._loadError && c.enderecos?.length > 0">
        <button type="button"
                class="mc-addr"
                *ngFor="let addr of c.enderecos"
                [class.is-selected]="selectedContact?.id === c.id && selectedAddress?.id === addr?.id"
                (click)="selectClient(c, addr); $event.stopPropagation()">
          <div class="mc-addr-left">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#64748b" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
            <div class="mc-addr-main">
              <span class="mc-addr-line">{{ getClientAddressPrimary(addr) }}</span>
              <span class="mc-addr-line-sub" *ngIf="getClientAddressSecondary(addr)">{{ getClientAddressSecondary(addr) }}</span>
            </div>
          </div>
          <span class="mc-addr-fee" *ngIf="hasClientAddressFee(addr)">+{{ formatCurrency(getClientAddressFeeValue(addr)) }}</span>
        </button>
      </div>

      <div class="mc-addr-empty" *ngIf="expandedClientId === c.id && !c._loadingDetails && !c._loadError && c._loaded && (!c.enderecos || c.enderecos.length === 0)">
        <div class="mc-addr-empty-card" (click)="$event.stopPropagation()">
          <span class="mc-addr-empty-title">Cliente sem endereços cadastrados</span>
          <span class="mc-addr-empty-sub" *ngIf="isDeliveryMode">Para entrega, escolha outro cliente ou cadastre um endereço. Você pode seguir com este cliente em retirada.</span>
          <button type="button"
                  class="mc-addr-empty-create"
                  (click)="openCreateClientAddressModal(c, $event)">
            Cadastrar endereço
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="mc-footer" *ngIf="!clientModalAddressOnly">
    <button type="button" class="mc-new-client-btn" (click)="openCreateClientModal($event)">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.4"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
      Novo cliente
    </button>
  </div>
</div>

<!-- ============================================ -->
<!-- MODAL — Venda Registrada                     -->
<!-- ============================================ -->
<div class="modal-backdrop modal-done-backdrop" *ngIf="orderDone"></div>
<div class="modal-done"
     *ngIf="orderDone"
     role="dialog"
     aria-modal="true"
     aria-labelledby="order-done-title"
     [attr.aria-busy]="orderDoneRedirecting">
  <div class="md-icon-circle">
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="20 6 9 17 4 12"/></svg>
  </div>
  <h2 class="md-title" id="order-done-title">Pedido criado com sucesso!</h2>

  <div class="md-order-number" *ngIf="orderDoneNumber" aria-live="polite">
    <span class="md-number-label">Código do pedido</span>
    <strong class="md-number">#{{ orderDoneNumber }}</strong>
  </div>
  <p class="md-number-missing" *ngIf="!orderDoneNumber">O pedido foi registrado.</p>

  <div class="md-actions">
    <button type="button"
            class="md-btn-confirm"
            (click)="continueAfterOrderDone()"
            [disabled]="orderDoneRedirecting"
            autofocus>
      {{ orderDoneRedirecting ? 'Continuando...' : 'Continuar' }}
      <span class="md-kbd md-kbd-confirm">Enter</span>
    </button>
  </div>
</div>
